

// import React, { useEffect, useMemo, useRef, useState } from "react";
// import axios from "axios";
// import { Link, useHistory, useParams } from "react-router-dom";
// import Slider from "react-slick";
// import { toast } from "react-toastify";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import "../styles/RecommendedProperties.css";
// import {
//   FiArrowLeft,
//   FiCamera,
//   FiCheckCircle,
//   FiChevronLeft,
//   FiChevronRight,
//   FiExternalLink,
//   FiFileText,
//   FiGrid,
//   FiHeart,
//   FiLayers,
//   FiMapPin,
//   FiMaximize2,
//   FiMessageCircle,
//   FiPhone,
//   FiShare2,
//   FiUser,
// } from "react-icons/fi";
// import {
//   FaBath,
//   FaBed,
//   FaBuilding,
//   FaCalendarCheck,
//   FaCar,
//   FaCheck,
//   FaClipboardList,
//   FaCoins,
//   FaCouch,
//   FaGem,
//   FaHome,
//   FaMoneyBillWave,
//   FaRulerCombined,
//   FaRupeeSign,
//   FaUsers,
//   FaWhatsapp,
// } from "react-icons/fa";
// import { PiCubeFocus } from "react-icons/pi";
// import Login1 from "../auth/Login1";
// import SignUp1 from "../auth/SignUp1";
// import GetScheduleVTourproperty from "../containers/GetScheduleVTourproperty";
// import ShareModal from "../containers/ShareModal";
// import ContactDetails from "../containers/ContactDetails";

// /* ------------------------------------------------------------------ */
// /* Constants & helpers (outside component so they never re-create)    */
// /* ------------------------------------------------------------------ */

// const API_BASE = process.env.REACT_APP_API_URL;
// const DEFAULT_IMAGE = "/image/appstore.png";
// const api = (path) => `${API_BASE}/cust_api/${path}`;

// const UNIT_TO_SQFT = {
//   "sq ft": 1,
//   sqft: 1,
//   "square feet": 1,
//   "sq yd": 9,
//   sqyd: 9,
//   "square yards": 9,
//   "sq mt": 10.7639,
//   sqmt: 10.7639,
//   "square meters": 10.7639,
//   acre: 43560,
//   acres: 43560,
// };

// const formatArea = (area, unit) => {
//   if (!area || !unit) return null;
//   const num = parseFloat(area);
//   if (isNaN(num)) return null;
//   const sqft = num * (UNIT_TO_SQFT[unit.toLowerCase()] ?? 1);
//   return `${Math.round(sqft).toLocaleString("en-IN")} Sq.Ft.`;
// };

// const formatINR = (value) =>
//   value ? `₹ ${Number(value).toLocaleString("en-IN")}` : null;

// const formatPriceShort = (price) => {
//   if (!price) return "";
//   if (price >= 10000000) return `${parseFloat((price / 10000000).toFixed(1))} Cr`;
//   if (price >= 100000) return `${parseFloat((price / 100000).toFixed(1))} L`;
//   if (price >= 1000) return `${parseFloat((price / 1000).toFixed(1))} K`;
//   return price;
// };

// const resolveImage = (src) => {
//   if (typeof src !== "string" || !src.trim()) return null;
//   return src.startsWith("http") ? src : `${API_BASE}${src}`;
// };

// const categoryBadge = (type) =>
//   type === "Rent"
//     ? { label: "FOR RENT", cls: "bg-blue-500" }
//     : type === "Buy"
//       ? { label: "FOR BUY", cls: "bg-green-600" }
//       : { label: "UNKNOWN", cls: "bg-gray-500" };

// const fallbackCopy = (text) => {
//   const area = document.createElement("textarea");
//   area.value = text;
//   area.style.position = "fixed";
//   area.style.left = "-9999px";
//   document.body.appendChild(area);
//   area.select();
//   try {
//     document.execCommand("copy") ? toast.success("Link copied!") : toast.error("Copy failed");
//   } catch {
//     toast.error("Copy failed");
//   }
//   document.body.removeChild(area);
// };

// /* ----- Overview fields: [label, key, icon] ------------------------- */
// const OVERVIEW_FIELDS = [
//   ["Status", "available_status", FiCheckCircle],
//   ["Added On", "property_added_date", FaCalendarCheck],
//   ["Listing Type", "property_category_type", FaHome],
//   ["Building Type", "building_type", FaBuilding],
//   ["Property Type", "property_type", FaBuilding],
//   ["BHK Type", "bhk_type", FaBed],
//   ["Furnishing", "furnished_type", FaCouch],
//   ["Area Type", "area_type", FaRulerCombined],
//   ["Operating Since", "operating_since", FaCalendarCheck],
//   ["Available For", "available_for", FaUsers],
//   ["Suited For", "suited_for", FaUsers],
//   ["Room Type", "room_type", FaBed],
//   ["Food Charges Included", "food_charges_included", FaMoneyBillWave],
//   ["Company Lease", "available_for_company_lease", FaClipboardList],
// ];

// /* ----- More-details fields grouped by category --------------------- */
// const DETAIL_CATEGORIES = [
//   {
//     id: "structure",
//     label: "Building & Structure",
//     icon: FaBuilding,
//     accent: "bg-indigo-50 text-indigo-600",
//     fields: [
//       ["Total Floor", "total_floor"],
//       ["Property Floor", "property_floor"],
//       ["Facing", "facing"],
//       ["Flooring", "flooring"],
//       ["Ceiling Height", "ceiling_height"],
//       ["Age of Property", "age_of_property"],
//       ["Type of Construction", "type_of_construction"],
//       ["Quality Rating", "quality_rating"],
//       ["Builder Floor Type", "builder_floor_type"],
//       ["Block", "block"],
//       ["Developer", "developer"],
//       ["Project Type", "project_type"],
//       ["Office Space Type", "office_space_type"],
//     ],
//   },
//   {
//     id: "parking",
//     label: "Parking & Utilities",
//     icon: FaCar,
//     accent: "bg-amber-50 text-amber-600",
//     fields: [
//       ["Covered Parking", "covered_parking"],
//       ["Uncovered Parking", "uncovered_parking"],
//       ["Parking Availability", "parking_availability"],
//       ["Parking Types", "parking_types"],
//       ["Total Parking", "total_number_parking"],
//       ["Lift Availability", "lift_availability"],
//       ["Power Backup", "power_backup"],
//       ["Water Source", "water_source"],
//       ["Central AC", "central_AC"],
//     ],
//   },
//   {
//     id: "rooms",
//     label: "Rooms & Spaces",
//     icon: FaBath,
//     accent: "bg-rose-50 text-rose-600",
//     fields: [
//       ["Total Beds", "total_beds"],
//       ["Available Beds", "available_beds"],
//       ["Additional Rooms", "additional_rooms"],
//       ["Bathroom", "bathroom"],
//       ["Attached Bathroom", "attached_bathroom"],
//       ["Min. Bathrooms", "number_of_minimum_bathrooms"],
//       ["Attached Balcony", "attached_balcony"],
//       ["Balcony", "balcony"],
//       ["Pantry", "pantry"],
//       ["Pantry Option", "pantry_option"],
//       ["Personal Washroom", "personal_washroom"],
//       ["Commercial Washroom", "commercial_washroom"],
//       ["No. of Cabins", "no_of_cabines"],
//       ["Meeting Rooms", "no_of_meeting_Rooms"],
//       ["Conference Rooms", "no_of_conference_room"],
//       ["Reception Area", "reception_area"],
//       ["No. of Peoples", "no_of_peoples"],
//       ["Seat Type", "seat_type"],
//       ["Seats Available", "number_of_seats_available"],
//       ["View", "view"],
//     ],
//   },
//   {
//     id: "lease",
//     label: "Lease & Possession",
//     icon: FaCalendarCheck,
//     accent: "bg-emerald-50 text-emerald-600",
//     fields: [
//       ["Notice Period", "notice_period"],
//       ["Notice Period (Days)", "notice_period_other_days"],
//       ["Min. Lock-in Period", "min_lockin_period"],
//       ["Possession Status", "possession_status"],
//       ["Possession Date", "possession_date"],
//       ["Possession By", "possession_by"],
//       ["Security Deposit Type", "security_deposit_type"],
//       ["Maintenance Frequency", "maintenance_frequency"],
//       ["Maintenance Cost", "maintenance_cost"],
//       ["Maintenance Included", "maintenance_included"],
//       ["Transaction Type", "transaction_type"],
//       ["Rent Duration", "rent_duration"],
//       ["Available From", "available_from"],
//       ["Available On", "available_on"],
//     ],
//   },
//   {
//     id: "charges",
//     label: "Charges & Pricing",
//     icon: FaMoneyBillWave,
//     accent: "bg-cyan-50 text-cyan-600",
//     fields: [
//       ["Electricity Charges Included", "electricity_charges_included"],
//       ["Tax & Govt. Charges", "tax_and_goverment_charges"],
//       ["Electricity & Water Charges", "electricity_and_water_charges"],
//       ["All Inclusive Price", "all_inclusive_price"],
//       ["Price Negotiable", "price_negotiable"],
//       ["Investment Options", "investment_options"],
//       ["Food Available", "food_available"],
//       ["PG Rules", "pg_rules"],
//       ["PG Services", "pg_services"],
//       ["Gate Closing Time", "gate_closing_time"],
//       ["Gate Closing Hour", "gate_closing_hour"],
//     ],
//   },
//   {
//     id: "land",
//     label: "Land & Dimensions",
//     icon: FaRulerCombined,
//     accent: "bg-violet-50 text-violet-600",
//     fields: [
//       ["Plot No.", "plot_no"],
//       ["Dimensions (L)", "property_dimensions_length"],
//       ["Dimensions (B)", "property_dimensions_breadth"],
//       ["Length of Land", "length_of_land"],
//       ["Breadth of Land", "breadthOfLand"],
//       ["Open Sides", "openSidesOfLand"],
//       ["No. of Open Sides", "no_of_open_sides"],
//       ["Construction on Land", "constructionOnLand"],
//       ["Selected Construction", "selectedConstructionOnLand"],
//       ["Carpet Area", "carpet_area"],
//       ["Carpet Area Unit", "carpet_area_unit"],
//     ],
//   },
//   {
//     id: "other",
//     label: "Other Details",
//     icon: FaClipboardList,
//     accent: "bg-slate-100 text-slate-600",
//     fields: [
//       ["RERA ID", "property_no"],
//       ["Landmarks", "landmarks"],
//       ["Near Landmark", "near_landmark"],
//       ["Flat Name", "flat_name"],
//     ],
//   },
// ];

// /* Tabs — Gallery and Location removed per request; gallery opens from
//    the thumbnail strip / "+N More" tile, and Location is still a
//    section further down the page, just not a tab anymore. */
// const TABS = [
//   { key: "overview", label: "Overview", icon: FiFileText },
//   { key: "amenities", label: "Amenities", icon: FiGrid },
//   { key: "similar", label: "Similar Properties", icon: FiLayers },
// ];

// const SIMILAR_SLIDER_SETTINGS = {
//   infinite: true,
//   slidesToShow: 3,
//   slidesToScroll: 1,
//   autoplay: true,
//   autoplaySpeed: 3500,
//   arrows: false,
//   responsive: [
//     { breakpoint: 1024, settings: { slidesToShow: 2 } },
//     { breakpoint: 640, settings: { slidesToShow: 1 } },
//   ],
// };

// /* ------------------------------------------------------------------ */
// /* Component                                                          */
// /* ------------------------------------------------------------------ */

// const Detail = () => {
//   const { _id } = useParams();
//   const history = useHistory();
//   const sliderRef = useRef(null);

//   const userId = sessionStorage.getItem("accessToken");
//   const userType = sessionStorage.getItem("user_type");

//   // Property data
//   const [propertyDetails, setPropertyDetails] = useState({});
//   const [propertyImages, setPropertyImages] = useState([]);
//   const [allAmenities, setAllAmenities] = useState([]);
//   const [aboutPropertyText, setAboutPropertyText] = useState("");
//   const [userDetails, setUserDetails] = useState({
//     full_name: "",
//     mobile_number: "",
//     email: "",
//   });
//   const [coords, setCoords] = useState({ lat: 0, lng: 0 });
//   const [tourSchedule, setTourSchedule] = useState([]);
//   const [scheduledDateLabel, setScheduledDateLabel] = useState("Virtual Tour");
//   const [similarProperties, setSimilarProperties] = useState([]);

//   // Favourites & view counts
//   const [isFavorite, setIsFavorite] = useState(false);
//   const [favoriteId, setFavoriteId] = useState(null);
//   const [freeViewCount, setFreeViewCount] = useState(0);
//   const [paidViewCount, setPaidViewCount] = useState(0);

//   // UI state
//   const [activeImg, setActiveImg] = useState(0);
//   const [activeTab, setActiveTab] = useState("overview");
//   const [showAllImages, setShowAllImages] = useState(false);
//   const [showAllAmenities, setShowAllAmenities] = useState(false);
//   const [openCategory, setOpenCategory] = useState(null); // first category auto-opens once data loads
//   const [isTourOpen, setIsTourOpen] = useState(false);
//   const [isContactOpen, setIsContactOpen] = useState(false);
//   const [isShareOpen, setIsShareOpen] = useState(false);
//   const [isLoginOpen, setIsLoginOpen] = useState(false);
//   const [isSignUpOpen, setIsSignUpOpen] = useState(false);
//   const [isLoggedIn, setIsLoggedIn] = useState(Boolean(userId));
//   const [pendingAction, setPendingAction] = useState(null); // "tour" | "contact"

//   // Enquiry form
//   const [name, setName] = useState("");
//   const [message, setMessage] = useState("");
//   const [contactNumber, setContactNumber] = useState(
//     () => sessionStorage.getItem("Mobile_Number") || "",
//   );
//   const [enquiryStatus, setEnquiryStatus] = useState(null);

//   /* ---------------------------- API calls ---------------------------- */

//   const checkPostLimits = async () => {
//     if (!userId) return;
//     try {
//       const form = new FormData();
//       form.append("user_id", userId);
//       const { data } = await axios.post(api("get_profile"), form);
//       const counts = data?.count_data;
//       if (counts) {
//         setFreeViewCount(counts.free_view_count || 0);
//         setPaidViewCount(counts.paid_view_count || 0);
//       }
//     } catch (err) {
//       console.error("Error checking post limits:", err);
//     }
//   };

//   const handleAddCount = async (updatedCount) => {
//     try {
//       const form = new FormData();
//       form.append(
//         freeViewCount > 0 ? "free_view_count" : "paid_view_count",
//         updatedCount,
//       );
//       form.append("user_id", userId);
//       const res = await fetch(api("add_count"), { method: "POST", body: form });
//       const data = await res.json();
//       if (res.ok) checkPostLimits();
//       else console.error("Failed to update count:", data.message);
//     } catch (err) {
//       console.error("API error:", err);
//     }
//   };

//   const fetchSimilarProperties = async () => {
//     try {
//       const { data } = await axios.post(api("get_featured_property"), {
//         user_id: userId,
//       });
//       setSimilarProperties(
//         data?.status === 1 && Array.isArray(data.data) ? data.data : [],
//       );
//     } catch (err) {
//       console.error("Error fetching similar properties:", err);
//     }
//   };

//   const checkIfFavorite = async (propertyId) => {
//     if (!userId || !propertyId) return;
//     try {
//       const { data } = await axios.post(api("get_favorite_properties"), {
//         user_id: userId,
//       });
//       const match = (data?.data || []).find(
//         (fav) => String(fav._id) === String(propertyId),
//       );
//       setIsFavorite(Boolean(match));
//       setFavoriteId(match?.favorite_id ?? null);
//     } catch (err) {
//       console.error("Error checking favorite status:", err);
//     }
//   };

//   const fetchPropertyDetails = async (id) => {
//     try {
//       const { data: res } = await axios.post(api("get_property_details"), {
//         property_id: id,
//         user_id: userId,
//       });
//       const data = res?.data || {};
//       const pd = data.property_details || {};

//       setPropertyImages(data.property_images || []);
//       setAllAmenities(data.amenities || []);
//       setAboutPropertyText(pd.property_description || "");
//       setPropertyDetails(pd);
//       setCoords({ lat: pd.latitude || 0, lng: pd.longitude || 0 });

//       const owner =
//         Array.isArray(data.user_details) && data.user_details.length
//           ? data.user_details[0]
//           : null;
//       setUserDetails(
//         owner || { full_name: "N/A", mobile_number: "N/A", email: "N/A" },
//       );

//       const schedule = data.tour_schedule?.[0];
//       if (schedule && !["Rejected", "Expired"].includes(schedule.status)) {
//         setTourSchedule(data.tour_schedule);
//         const [year, month, day] = schedule.schedule_date.split("-");
//         const monthName = new Date(0, parseInt(month, 10) - 1).toLocaleString(
//           "default",
//           { month: "short" },
//         );
//         setScheduledDateLabel(
//           `Scheduled ${parseInt(day, 10)} ${monthName} ${year.slice(-2)}`,
//         );
//       } else {
//         setTourSchedule([]);
//         setScheduledDateLabel("Virtual Tour");
//       }
//     } catch (err) {
//       console.error("Error fetching property details", err);
//       setPropertyImages([]);
//       setAllAmenities([]);
//       setTourSchedule([]);
//     }
//   };

//   const toggleFavorite = async ({ propertyId, favId, saved }) => {
//     if (!userId) {
//       setIsLoginOpen(true);
//       return;
//     }
//     try {
//       if (saved) {
//         await axios.delete(api("remove_from_favorite"), {
//           data: { favorite_id: favId },
//         });
//         toast.success("Property removed from your favorites.");
//       } else {
//         await axios.post(api("add_to_favorite"), {
//           user_id: userId,
//           property_id: propertyId,
//         });
//         toast.success("Property has been saved to your favorites!");
//       }
//       checkIfFavorite(propertyDetails?._id);
//       fetchSimilarProperties();
//     } catch (err) {
//       console.error("Favorite update failed:", err);
//       toast.error("Could not update favourites. Please try again.");
//     }
//   };

//   const handleEnquirySubmit = async (e) => {
//     e.preventDefault();
//     if (!userId) {
//       setIsLoginOpen(true);
//       return;
//     }
//     try {
//       const { data } = await axios.post(api("add_property_enquiry"), {
//         property_id: propertyDetails?._id,
//         user_id: propertyDetails?.user_id,
//         customer_id: userId,
//         name,
//         user_type: userType,
//         contact_number: contactNumber,
//         message,
//       });
//       if (data?.status) {
//         setEnquiryStatus({ type: "success", message: "Enquiry sent successfully!" });
//         setName("");
//         setMessage("");
//       } else {
//         setEnquiryStatus({ type: "error", message: "Failed to send enquiry!" });
//       }
//     } catch {
//       setEnquiryStatus({ type: "error", message: "Something went wrong!" });
//     }
//   };

//   /* ----------------------------- Effects ----------------------------- */

//   useEffect(() => {
//     checkPostLimits();
//     fetchSimilarProperties();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   useEffect(() => {
//     window.scrollTo(0, 0);
//     setActiveImg(0);
//     fetchPropertyDetails(_id);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [_id]);

//   useEffect(() => {
//     checkIfFavorite(propertyDetails?._id);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [propertyDetails?._id]);

//   useEffect(() => {
//     const d = propertyDetails;
//     if (!d?._id || !d?.user_id || !userId) return;
//     const form = new FormData();
//     form.append("property_id", d._id);
//     form.append("user_id", d.user_id);
//     form.append("customer_id", userId);
//     axios
//       .post(api("add_view_property"), form)
//       .catch((err) => console.error("Failed to record property view:", err));
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [propertyDetails?._id]);

//   // Resume whatever the user tried before logging in
//   useEffect(() => {
//     if (!isLoggedIn || !pendingAction) return;
//     if (pendingAction === "tour") setIsTourOpen(true);
//     if (pendingAction === "contact") {
//       checkPostLimits();
//       setIsContactOpen(true);
//     }
//     setPendingAction(null);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [isLoggedIn, pendingAction]);

//   // Lock background scroll while a modal is open
//   useEffect(() => {
//     const locked = isShareOpen || isContactOpen || showAllImages || isTourOpen;
//     document.body.style.overflow = locked ? "hidden" : "auto";
//     return () => {
//       document.body.style.overflow = "auto";
//     };
//   }, [isShareOpen, isContactOpen, showAllImages, isTourOpen]);

//   /* ----------------------------- Handlers ---------------------------- */

//   const requireLogin = (action) => {
//     if (userId) return true;
//     setPendingAction(action);
//     setIsLoginOpen(true);
//     return false;
//   };

//   const handleLoginSuccess = () => {
//     const mobile = sessionStorage.getItem("Mobile_Number");
//     if (!mobile) return;
//     setContactNumber(mobile);
//     setIsLoginOpen(false);
//     setIsLoggedIn(true);
//   };

//   const handleContactClick = () => {
//     if (!requireLogin("contact")) return;
//     if (!userDetails?.full_name) {
//       toast.error("User data not found");
//       return;
//     }
//     if (freeViewCount > 0) {
//       setFreeViewCount(-1);
//       handleAddCount(-1);
//     } else if (paidViewCount > 0) {
//       setPaidViewCount(-1);
//       handleAddCount(-1);
//     }
//     setIsContactOpen(true);
//   };

//   const handleTourClick = () => {
//     if (scheduledDateLabel !== "Virtual Tour") {
//       history.push({ pathname: "/dashboard", state: { page: "myVirtualtour" } });
//       return;
//     }
//     if (requireLogin("tour")) setIsTourOpen(true);
//   };

//   const copyLink = async () => {
//     const url = window.location.href;
//     try {
//       await navigator.clipboard.writeText(url);
//       toast.success("Link copied!");
//     } catch {
//       fallbackCopy(url);
//     }
//   };

//   const scrollToEnquiry = () =>
//     document
//       .getElementById("enquiry")
//       ?.scrollIntoView({ behavior: "smooth", block: "center" });

//   const goToTab = (key) => {
//     setActiveTab(key);
//     document
//       .getElementById(`sec-${key}`)
//       ?.scrollIntoView({ behavior: "smooth", block: "start" });
//   };

//   const handleBack = () => (history.length > 1 ? history.goBack() : history.push("/"));

//   /* ----------------------------- Derived ----------------------------- */

//   const d = propertyDetails || {};
//   const isRent = d.property_category_type === "Rent";
//   const headlinePrice = isRent ? d.rent : d.property_price;
//   const locality = [d.address_area, d.city_name].filter(Boolean).join(", ");
//   const fullAddress = [d.address, d.city_name, d.state, d.zip_code]
//     .filter(Boolean)
//     .join(", ");
//   const mapsLink =
//     coords.lat && coords.lng
//       ? `https://www.google.com/maps?q=${coords.lat},${coords.lng}`
//       : null;
//   const mapEmbed = `https://maps.google.com/maps?q=${coords.lat},${coords.lng}&z=15&output=embed`;

//   const galleryImages = useMemo(
//     () =>
//       [
//         ...new Set(
//           [d.cover_image, ...propertyImages.map((i) => i.image)]
//             .map(resolveImage)
//             .filter(Boolean),
//         ),
//       ],
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     [d.cover_image, propertyImages],
//   );

//   const hasVideo = Boolean(d.property_video);
//   const totalPhotos = galleryImages.length + (hasVideo ? 1 : 0);
//   const currentImage = galleryImages[activeImg] || galleryImages[0] || DEFAULT_IMAGE;
//   const extraCount = Math.max(galleryImages.length - 4, 0) + (hasVideo ? 1 : 0);

//   const stepImage = (dir) => {
//     if (!galleryImages.length) return;
//     setActiveImg((i) => (i + dir + galleryImages.length) % galleryImages.length);
//   };

//   const isLocked = freeViewCount <= 0 && paidViewCount <= 0;

//   const stats = [
//     headlinePrice && {
//       icon: FaRupeeSign,
//       label: isRent
//         ? d.all_inclusive_price === "Yes"
//           ? "Rent (Inclusive)"
//           : "Rent"
//         : "Price",
//       value: `${formatINR(headlinePrice)}${isRent ? " / Month" : ""
//         }${isRent && d.rent_duration ? ` (${d.rent_duration})` : ""}`,
//     },
//     d.custom_deposit_amount && {
//       icon: FaCoins,
//       label: "Security Deposit",
//       value: formatINR(d.custom_deposit_amount),
//     },
//     d.area && {
//       icon: FaRulerCombined,
//       label: "Built-up Area",
//       value: formatArea(d.area, d.area_in),
//     },
//   ].filter((s) => s && s.value);

//   const chips = [
//     { icon: FaBed, title: d.bhk_type, sub: d.property_type || "Property Type" },
//     { icon: FaCouch, title: d.furnished_type, sub: "Furnishing" },
//     {
//       icon: FaUsers,
//       title: d.suited_for || d.available_for,
//       sub: isRent ? "Preferred Tenants" : "Suited For",
//     },
//     { icon: FaCalendarCheck, title: d.available_status, sub: "Availability" },
//   ].filter((c) => c.title);

//   const highlights = useMemo(() => {
//     if (Array.isArray(d.key_highlights) && d.key_highlights.length) return d.key_highlights;
//     return [
//       d.furnished_type && `${d.furnished_type} property`,
//       d.lift_availability && `Lift: ${d.lift_availability}`,
//       d.power_backup && `Power backup: ${d.power_backup}`,
//       d.facing && `${d.facing} facing`,
//       d.parking_availability && `Parking: ${d.parking_availability}`,
//       (d.near_landmark || d.landmarks) && `Near ${d.near_landmark || d.landmarks}`,
//       d.water_source && `Water: ${d.water_source}`,
//     ].filter(Boolean);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [propertyDetails]);

//   const overviewTiles = [
//     { label: "Address", value: fullAddress, icon: FiMapPin },
//     { label: "Area", value: formatArea(d.area, d.area_in), icon: FaRulerCombined },
//     ...OVERVIEW_FIELDS.map(([label, key, icon]) => ({ label, value: d[key], icon })),
//   ].filter((t) => t.value);

//   const detailGroups = useMemo(
//     () =>
//       DETAIL_CATEGORIES.map((cat) => ({
//         ...cat,
//         rows: cat.fields
//           .map(([label, key]) => [
//             label,
//             key === "maintenance_included"
//               ? d.maintenance_included
//                 ? "Yes"
//                 : null
//               : d[key],
//           ])
//           .filter(([, value]) => value),
//       })).filter((cat) => cat.rows.length > 0),
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     [propertyDetails],
//   );

//   useEffect(() => {
//     if (detailGroups.length > 0 && openCategory === null) {
//       setOpenCategory(detailGroups[0].id);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [detailGroups.length]);

//   const visibleAmenities = showAllAmenities ? allAmenities : allAmenities.slice(0, 9);

//   const tourButtonClass =
//     tourSchedule?.[0]?.status === "Accepted"
//       ? "bg-green-600 text-white"
//       : scheduledDateLabel === "Virtual Tour"
//         ? "bg-white border border-[#7a1630] text-[#7a1630]"
//         : "bg-[#c98a1b] text-white";

//   /* ------------------------------ Render ----------------------------- */

//   return (
//     <div className="min-h-screen bg-white pb-20 lg:pb-8">
//       {/* Compact top bar */}

//       <main className="max-w-7xl px-4 mx-auto mt-4 sm:px-6">
//         {/* ============ HERO: compact gallery (left) + info panel (right) ============ */}
//         <section className="grid items-start grid-cols-1 gap-3 lg:grid-cols-12">
//           {/* Gallery + Overview — left column */}
//           <div className="flex flex-col gap-2.5 lg:col-span-5">
//             <div className="relative overflow-hidden bg-white shadow-sm rounded-2xl">
//               <img
//                 src={currentImage}
//                 alt={d.property_name || "Property"}
//                 onClick={() => setShowAllImages(true)}
//                 className="object-cover w-full cursor-zoom-in h-40 sm:h-58 lg:h-68"
//               />

//               <span
//                 className={`absolute top-2.5 left-2.5 flex items-center gap-1.5 px-2.5 py-1 text-[11px] font-semibold text-white rounded-lg shadow ${isRent ? "bg-[#7a1630]" : "bg-green-600"
//                   }`}
//               >
//                 <FaHome size={11} /> {isRent ? "For Rent" : "For Sale"}
//               </span>

//               <button
//                 type="button"
//                 aria-label="View all photos"
//                 onClick={() => setShowAllImages(true)}
//                 className="absolute flex items-center justify-center w-7 h-7 text-white rounded-full top-2.5 right-2.5 bg-black/40"
//               >
//                 <FiMaximize2 size={13} />
//               </button>

//               {galleryImages.length > 1 && (
//                 <>
//                   <button
//                     type="button"
//                     aria-label="Previous photo"
//                     onClick={() => stepImage(-1)}
//                     className="absolute flex items-center justify-center w-7 h-7 text-white -translate-y-1/2 rounded-full left-2 top-1/2 bg-black/40"
//                   >
//                     <FiChevronLeft size={15} />
//                   </button>
//                   <button
//                     type="button"
//                     aria-label="Next photo"
//                     onClick={() => stepImage(1)}
//                     className="absolute flex items-center justify-center w-7 h-7 text-white -translate-y-1/2 rounded-full right-2 top-1/2 bg-black/40"
//                   >
//                     <FiChevronRight size={15} />
//                   </button>
//                 </>
//               )}

//               {totalPhotos > 0 && (
//                 <span className="absolute flex items-center gap-1.5 px-2 py-0.5 text-[11px] text-white rounded-lg bottom-2.5 left-2.5 bg-black/50">
//                   <FiCamera size={11} /> {Math.min(activeImg + 1, totalPhotos)} / {totalPhotos}
//                 </span>
//               )}
//             </div>

//             {galleryImages.length > 0 && (
//               <div className="grid grid-cols-5 gap-1.5">
//                 {galleryImages.slice(0, 4).map((src, i) => (
//                   <button
//                     type="button"
//                     key={src}
//                     onClick={() => setActiveImg(i)}
//                     className={`h-12 sm:h-14 overflow-hidden rounded-lg border-2 ${i === activeImg ? "border-[#7a1630]" : "border-transparent"
//                       }`}
//                   >
//                     <img src={src} alt="" className="object-cover w-full h-full" />
//                   </button>
//                 ))}
//                 {extraCount > 0 && (
//                   <button
//                     type="button"
//                     onClick={() => setShowAllImages(true)}
//                     className="flex flex-col items-center justify-center h-12 text-xs font-semibold text-[#7a1630] bg-white border rounded-lg sm:h-14 border-slate-200"
//                   >
//                     +{extraCount}
//                     <span className="text-[9px] font-normal text-gray-500">More</span>
//                   </button>
//                 )}
//               </div>
//             )}

//             {/* Overview sits under the gallery to fill the empty left column */}
//             {overviewTiles.length > 0 && (
//               <section
//                 id="sec-overview"
//                 className="p-3 bg-white shadow-sm scroll-mt-16 rounded-2xl"
//               >
//                 <h2 className="flex items-center gap-2 text-sm font-bold text-gray-900">
//                   <span className="flex items-center justify-center w-7 h-7 rounded-lg bg-[#fbf1f3] text-[#7a1630]">
//                     <FiFileText size={13} />
//                   </span>
//                   Overview
//                 </h2>
//                 <div className="grid grid-cols-2 gap-2 mt-2.5">
//                   {overviewTiles.map(({ label, value, icon: Icon }) => (
//                     <div
//                       key={label}
//                       className="flex items-start gap-2 p-2 border rounded-lg border-slate-100 bg-slate-50/70"
//                     >
//                       <span className="flex items-center justify-center w-7 h-7 text-[#7a1630] bg-white rounded-md shadow-sm shrink-0">
//                         <Icon size={12} />
//                       </span>
//                       <div className="min-w-0">
//                         <p className="text-[10px] text-gray-500 leading-tight">{label}</p>
//                         <p className="text-xs font-semibold text-gray-900 break-words leading-snug">
//                           {value}
//                         </p>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </section>
//             )}
//           </div>

//           {/* Info panel — right, holds everything important */}
//           <div className="lg:col-span-7">
//             <div className="p-3 bg-white shadow-sm rounded-2xl">
//               <h1 className="text-lg font-bold leading-snug text-gray-900 sm:text-xl">
//                 {d.property_name || "Property"}
//                 {d.property_no && (
//                   <span className="ml-1.5 text-xs font-normal text-gray-400">
//                     – {d.property_no}
//                   </span>
//                 )}
//               </h1>

//               <div className="flex flex-wrap items-center gap-x-2 gap-y-1 mt-1 text-xs text-gray-600">
//                 <span className="flex items-center gap-1">
//                   <FiMapPin className="text-[#7a1630] shrink-0" size={12} />
//                   {locality || "Address N/A"}
//                 </span>
//                 {mapsLink && (
//                   <>
//                     <span className="text-gray-300">|</span>
//                     <a
//                       href={mapsLink}
//                       target="_blank"
//                       rel="noreferrer"
//                       className="font-medium text-[#7a1630] hover:underline"
//                     >
//                       Explore Nearby
//                     </a>
//                   </>
//                 )}
//               </div>

//               {/* Price strip */}
//               {stats.length > 0 && (
//                 <div className="grid grid-cols-1 mt-2 overflow-hidden divide-y rounded-xl bg-[#fbf1f3] sm:grid-cols-3 sm:divide-x sm:divide-y-0">
//                   {stats.map(({ icon: Icon, label, value }) => (
//                     <div key={label} className="flex items-center gap-2 p-2">
//                       <span className="flex items-center justify-center w-7 h-7 text-[#7a1630] bg-white rounded-full shrink-0">
//                         <Icon size={12} />
//                       </span>
//                       <div className="min-w-0">
//                         <p className="text-sm font-bold text-[#7a1630] truncate">{value}</p>
//                         <p className="text-[10px] text-gray-500 leading-tight">{label}</p>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               )}

//               {/* Feature chips */}
//               {chips.length > 0 && (
//                 <div className="grid grid-cols-2 gap-1.5 mt-2">
//                   {chips.map(({ icon: Icon, title, sub }) => (
//                     <div
//                       key={sub}
//                       className="flex items-center gap-1.5 p-1.5 border rounded-lg border-slate-200"
//                     >
//                       <Icon className="text-[#7a1630] shrink-0" size={13} />
//                       <div className="min-w-0">
//                         <p className="text-xs font-semibold text-gray-900 truncate">{title}</p>
//                         <p className="text-[10px] text-gray-500 leading-tight">{sub}</p>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               )}

//               {/* Actions — gated through the same login/view-limit flow as before */}
//               <div className="flex gap-1.5 mt-2">
//                 <button
//                   type="button"
//                   onClick={handleContactClick}
//                   className="flex items-center justify-center flex-1 gap-1.5 py-2 text-xs font-semibold text-white bg-[#7a1630] rounded-lg hover:bg-[#611126]"
//                 >
//                   <FiPhone size={13} /> Call Owner
//                 </button>
//                 <button
//                   type="button"
//                   onClick={handleContactClick}
//                   className="flex items-center justify-center flex-1 gap-1.5 py-2 text-xs font-semibold text-[#7a1630] bg-white border-2 border-[#7a1630] rounded-lg hover:bg-[#fbf1f3]"
//                 >
//                   <FaWhatsapp size={13} /> WhatsApp
//                 </button>
//               </div>
//               <div className="flex gap-1.5 mt-1.5">
//                 <button
//                   type="button"
//                   onClick={scrollToEnquiry}
//                   className="flex items-center justify-center flex-1 gap-1.5 py-2 text-xs font-semibold text-white bg-[#c98a1b] rounded-lg hover:brightness-95"
//                 >
//                   <FiMessageCircle size={13} /> Enquire Now
//                 </button>
//                 <button
//                   type="button"
//                   aria-label="Save property"
//                   onClick={() =>
//                     d._id &&
//                     toggleFavorite({ propertyId: d._id, favId: favoriteId, saved: isFavorite })
//                   }
//                   className="flex items-center justify-center bg-white border rounded-lg w-9 border-slate-200"
//                 >
//                   <FiHeart
//                     size={14}
//                     className={isFavorite ? "fill-red-600 text-red-600" : "text-gray-600"}
//                   />
//                 </button>
//               </div>

//               {d.virtual_tour_availability === "Yes" && (
//                 <button
//                   type="button"
//                   onClick={handleTourClick}
//                   className={`flex items-center justify-center w-full gap-1.5 py-2 mt-1.5 text-xs font-semibold rounded-lg ${tourButtonClass}`}
//                 >
//                   <PiCubeFocus size={15} />
//                   {scheduledDateLabel}
//                 </button>
//               )}
//             </div>

//             {/* Owner card */}
//             <div className="flex items-center justify-between gap-3 p-2.5 mt-2 bg-white border shadow-sm rounded-2xl border-amber-100">
//               <div className="flex items-center min-w-0 gap-2.5">
//                 {userDetails?._id ? (
//                   <Link to={`/agentdetail/${userDetails._id}`} className="shrink-0">
//                     {userDetails.profile_image ? (
//                       <img
//                         src={userDetails.profile_image}
//                         alt="Owner"
//                         className="object-cover rounded-full w-9 h-9"
//                       />
//                     ) : (
//                       <span className="flex items-center justify-center text-white rounded-full w-9 h-9 bg-[#7a1630]">
//                         <FiUser size={14} />
//                       </span>
//                     )}
//                   </Link>
//                 ) : (
//                   <span className="flex items-center justify-center text-white rounded-full shrink-0 w-9 h-9 bg-[#7a1630]">
//                     <FiUser size={14} />
//                   </span>
//                 )}
//                 <div className="min-w-0">
//                   <p className="text-xs font-semibold text-gray-900 truncate">
//                     {userDetails?.full_name || "N/A"}
//                   </p>
//                   {userDetails?.is_verified ? (
//                     <p className="flex items-center gap-1 text-[11px] font-medium text-green-600">
//                       <FiCheckCircle size={11} /> Verified Owner
//                     </p>
//                   ) : (
//                     userDetails?.user_type && (
//                       <p className="text-[11px] text-gray-500">{userDetails.user_type}</p>
//                     )
//                   )}
//                 </div>
//               </div>
//               <button
//                 type="button"
//                 onClick={scrollToEnquiry}
//                 className="px-3 py-1.5 text-[11px] font-semibold text-green-800 bg-green-100 rounded-lg whitespace-nowrap hover:bg-green-200"
//               >
//                 Start Chat
//               </button>
//             </div>
//           </div>
//         </section>

//         {/* ============ TABS — pushed up, Gallery & Location removed ============ */}
//         <nav className="sticky z-30 mt-1.5 overflow-x-auto bg-white border shadow-sm top-0 rounded-xl border-slate-100">
//           <ul className="flex min-w-max">
//             {TABS.map(({ key, label, icon: Icon }) => (
//               <li key={key} className="flex-1">
//                 <button
//                   type="button"
//                   onClick={() => goToTab(key)}
//                   className={`flex w-full items-center justify-center gap-1.5 px-3.5 py-2 text-xs font-medium border-b-2 ${activeTab === key
//                       ? "border-[#7a1630] text-[#7a1630]"
//                       : "border-transparent text-gray-600 hover:text-[#7a1630]"
//                     }`}
//                 >
//                   <Icon size={13} /> {label}
//                 </button>
//               </li>
//             ))}
//           </ul>
//         </nav>

//         {/* ============ CONTENT ============ */}
//         <section className="flex flex-col gap-3 mt-3">
//           {/* Description + highlights */}
//           <div className="grid gap-3 p-3.5 bg-white shadow-sm rounded-2xl md:grid-cols-5">
//             <div className="md:col-span-3">
//               <h2 className="pl-2.5 text-sm font-bold text-gray-900 border-l-4 border-[#7a1630]">
//                 Property Description
//               </h2>
//               <p className="mt-1.5 text-sm leading-relaxed text-gray-700 whitespace-pre-line">
//                 {aboutPropertyText || "No description provided."}
//               </p>
//             </div>

//             {highlights.length > 0 && (
//               <div className="p-3 md:col-span-2 rounded-xl bg-[#fbf1f3]">
//                 <h3 className="flex items-center gap-1.5 text-xs font-bold text-[#7a1630]">
//                   <FaGem size={11} /> Key Highlights
//                 </h3>
//                 <ul className="mt-1.5 space-y-1 text-xs text-gray-800">
//                   {highlights.map((h) => (
//                     <li key={h} className="flex gap-1.5">
//                       <FaCheck className="mt-0.5 text-[#7a1630] shrink-0" size={10} />
//                       <span>{h}</span>
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             )}
//           </div>

//           {/* More Details — grouped, collapsible categories */}
//           {detailGroups.length > 0 && (
//             <section className="p-3.5 bg-white shadow-sm rounded-2xl">
//               <h2 className="text-sm font-bold text-gray-900">More Details</h2>
//               <div className="mt-2.5 space-y-2">
//                 {detailGroups.map((cat) => {
//                   const isOpen = openCategory === cat.id;
//                   const Icon = cat.icon;
//                   return (
//                     <div key={cat.id} className="overflow-hidden border rounded-xl border-slate-100">
//                       <button
//                         type="button"
//                         onClick={() => setOpenCategory(isOpen ? null : cat.id)}
//                         className="flex items-center justify-between w-full gap-2 p-2.5 text-left hover:bg-slate-50"
//                       >
//                         <span className="flex items-center gap-2 min-w-0">
//                           <span className={`flex items-center justify-center w-7 h-7 rounded-lg shrink-0 ${cat.accent}`}>
//                             <Icon size={12} />
//                           </span>
//                           <span className="text-xs font-semibold text-gray-900 truncate">{cat.label}</span>
//                           <span className="text-[10px] text-gray-400">({cat.rows.length})</span>
//                         </span>
//                         <FiChevronRight
//                           size={14}
//                           className={`text-gray-400 transition-transform shrink-0 ${isOpen ? "rotate-90" : ""}`}
//                         />
//                       </button>
//                       {isOpen && (
//                         <div className="grid grid-cols-1 gap-x-4 gap-y-1.5 p-3 pt-0 sm:grid-cols-2">
//                           {cat.rows.map(([label, value]) => (
//                             <div key={label} className="flex items-baseline justify-between gap-3 py-1 text-xs border-b border-slate-50">
//                               <span className="text-gray-500">{label}</span>
//                               <span className="font-medium text-right text-gray-900 break-words">{value}</span>
//                             </div>
//                           ))}
//                         </div>
//                       )}
//                     </div>
//                   );
//                 })}
//               </div>
//             </section>
//           )}

//           {/* Amenities — colored icon tiles */}
//           {allAmenities.length > 0 && (
//             <section id="sec-amenities" className="p-3.5 bg-white shadow-sm scroll-mt-16 rounded-2xl">
//               <h2 className="text-sm font-bold text-gray-900">Amenities</h2>
//               <div className="grid grid-cols-3 gap-2.5 mt-2.5 sm:grid-cols-4 md:grid-cols-5">
//                 {visibleAmenities.map((amenity, i) => (
//                   <div
//                     key={`${amenity.name}-${i}`}
//                     className="flex flex-col items-center gap-1.5 p-2.5 text-center border rounded-xl border-slate-100 bg-slate-50/60"
//                   >
//                     {amenity.icon ? (
//                       <img
//                         src={`${API_BASE}/media/${amenity.icon}`}
//                         alt={amenity.name}
//                         className="object-contain w-7 h-7"
//                       />
//                     ) : (
//                       <span className="flex items-center justify-center w-9 h-9 rounded-full bg-[#fbf1f3] text-[#7a1630]">
//                         <FiCheckCircle size={15} />
//                       </span>
//                     )}
//                     <span className="text-[11px] font-medium text-gray-700 leading-tight line-clamp-2">
//                       {amenity.name}
//                     </span>
//                   </div>
//                 ))}
//               </div>
//               {allAmenities.length > 9 && (
//                 <button
//                   type="button"
//                   onClick={() => setShowAllAmenities((s) => !s)}
//                   className="mt-3 text-xs font-semibold text-[#7a1630] hover:underline"
//                 >
//                   {showAllAmenities ? "Show less" : `+${allAmenities.length - 9} More`}
//                 </button>
//               )}
//             </section>
//           )}


//           {/* Enquiry form */}
//           <section id="enquiry" className="p-3.5 bg-white shadow-sm scroll-mt-16 rounded-2xl">
//             <h3 className="flex items-center gap-2 text-sm font-bold text-gray-900">
//               <span className="flex items-center justify-center w-7 h-7 rounded-lg bg-[#fbf1f3] text-[#7a1630]">
//                 <FiMessageCircle size={13} />
//               </span>
//               Make an Enquiry
//             </h3>
//             <form onSubmit={handleEnquirySubmit} className="grid gap-2 mt-2.5 sm:grid-cols-2">
//               <input
//                 type="text"
//                 placeholder="Your name"
//                 value={name}
//                 onChange={(e) => setName(e.target.value)}
//                 onFocus={() => !userId && setIsLoginOpen(true)}
//                 required
//                 className="w-full p-2 text-xs border rounded-lg outline-none focus:ring-2 focus:ring-[#7a1630]"
//               />
//               <input
//                 type="text"
//                 placeholder="Phone number"
//                 value={contactNumber}
//                 readOnly
//                 className="w-full p-2 text-xs bg-gray-50 border rounded-lg outline-none"
//               />
//               <textarea
//                 placeholder="Message"
//                 rows={3}
//                 value={message}
//                 onChange={(e) => setMessage(e.target.value)}
//                 onFocus={() => !userId && setIsLoginOpen(true)}
//                 required
//                 className="w-full p-2 text-xs border rounded-lg outline-none focus:ring-2 focus:ring-[#7a1630] sm:col-span-2"
//               />
//               <button
//                 type="submit"
//                 className="w-full py-2 text-xs font-semibold text-white bg-[#c98a1b] rounded-lg hover:brightness-95 sm:col-span-2"
//               >
//                 Send an Enquiry
//               </button>
//             </form>
//             {enquiryStatus && (
//               <p
//                 className={`mt-2 text-center text-xs ${enquiryStatus.type === "success" ? "text-green-600" : "text-red-600"
//                   }`}
//               >
//                 {enquiryStatus.message}
//               </p>
//             )}
//           </section>

//           {/* Location — still shown as a section, just not a tab anymore */}
//           <section id="sec-location" className="p-3.5 bg-white shadow-sm scroll-mt-16 rounded-2xl">
//             <div className="flex items-center justify-between">
//               <h2 className="flex items-center gap-2 text-sm font-bold text-gray-900">
//                 <span className="flex items-center justify-center w-7 h-7 rounded-lg bg-[#fbf1f3] text-[#7a1630]">
//                   <FiMapPin size={13} />
//                 </span>
//                 Location
//               </h2>
//               {mapsLink && (
//                 <a
//                   href={mapsLink}
//                   target="_blank"
//                   rel="noreferrer"
//                   className="flex items-center gap-1 text-xs font-medium text-[#7a1630] hover:underline"
//                 >
//                   Open in Maps <FiExternalLink size={12} />
//                 </a>
//               )}
//             </div>
//             <p className="mt-1 ml-9 text-xs text-gray-500">{fullAddress || "Address N/A"}</p>
//             <div className="mt-2.5 overflow-hidden rounded-xl">
//               <iframe
//                 title="Property location"
//                 src={mapEmbed}
//                 className="w-full h-48 md:h-64"
//                 allowFullScreen
//                 loading="lazy"
//               />
//             </div>
//           </section>



//           {/* Similar properties */}
//           {similarProperties.length > 0 && (
//             <section id="sec-similar" className="p-3.5 bg-white shadow-sm scroll-mt-16 rounded-2xl">
//               <div className="flex flex-wrap items-center justify-between gap-2 mb-2.5">
//                 <div>
//                   <h2 className="text-sm font-bold text-gray-900">Exclusive Recommended</h2>
//                   <p className="text-[11px] text-gray-500">Go from browsing to buying</p>
//                 </div>
//                 <div className="flex items-center gap-1.5">
//                   <button
//                     type="button"
//                     onClick={() => history.push("/featuredDashboard")}
//                     className="px-2.5 py-1 text-[11px] font-medium text-[#7a1630] bg-white border rounded-lg border-[#7a1630]"
//                   >
//                     View All
//                   </button>
//                   <button
//                     type="button"
//                     aria-label="Previous"
//                     onClick={() => sliderRef.current?.slickPrev()}
//                     className="flex items-center justify-center w-7 h-7 bg-white border rounded-full shadow-sm"
//                   >
//                     <FiChevronLeft size={13} />
//                   </button>
//                   <button
//                     type="button"
//                     aria-label="Next"
//                     onClick={() => sliderRef.current?.slickNext()}
//                     className="flex items-center justify-center w-7 h-7 bg-white border rounded-full shadow-sm"
//                   >
//                     <FiChevronRight size={13} />
//                   </button>
//                 </div>
//               </div>

//               <Slider {...SIMILAR_SLIDER_SETTINGS} ref={sliderRef} className="slider-container">
//                 {similarProperties.map((p) => {
//                   const badge = categoryBadge(p.property_category_type);
//                   const cardPrice = p.property_category_type === "Rent" ? p.rent : p.property_price;
//                   return (
//                     <div key={p._id} className="px-1.5 py-1">
//                       <div className="relative overflow-hidden bg-white border shadow-sm rounded-xl border-slate-100">
//                         <Link
//                           to={`/propertydetails/${p._id}?property_owner_id=${p.user_id}`}
//                           onClick={() => window.scrollTo(0, 0)}
//                           className="block"
//                         >
//                           <div className="relative">
//                             <img
//                               src={resolveImage(p.cover_image) || DEFAULT_IMAGE}
//                               alt={p.property_name || "Property"}
//                               className="object-cover w-full h-32"
//                             />
//                             <span className="absolute px-2 py-0.5 text-[10px] text-white rounded-full top-1.5 left-1.5 bg-black/50">
//                               {p.days_since_created}d on ZeroBriks
//                             </span>
//                             <span
//                               className={`absolute bottom-0 left-0 px-2.5 py-0.5 text-[10px] text-white rounded-tr-lg ${badge.cls}`}
//                             >
//                               {badge.label}
//                             </span>
//                             {p.mark_as_featured === "Yes" && (
//                               <span className="absolute bottom-0 right-0 px-2.5 py-0.5 text-[10px] text-white rounded-tl-lg bg-amber-500">
//                                 FEATURED
//                               </span>
//                             )}
//                           </div>

//                           <div className="p-2.5">
//                             <h3 className="text-xs font-semibold text-gray-900 truncate">{p.property_name}</h3>
//                             <p className="flex items-center gap-1 mt-1 text-[11px] text-gray-500 truncate">
//                               <FiMapPin size={10} className="shrink-0" />
//                               {p.address_area || "No Address Provided"}
//                             </p>
//                             <div className="flex flex-wrap gap-x-2.5 gap-y-0.5 mt-1.5 text-[11px] text-gray-700">
//                               {cardPrice && (
//                                 <span className="font-semibold text-[#7a1630]">
//                                   ₹{formatPriceShort(cardPrice)}
//                                   {p.property_category_type === "Rent" && p.rent_duration
//                                     ? ` / ${p.rent_duration}`
//                                     : ""}
//                                 </span>
//                               )}
//                               {p.bhk_type && <span>{p.bhk_type}</span>}
//                               {formatArea(p.area, p.area_in) && <span>{formatArea(p.area, p.area_in)}</span>}
//                             </div>
//                           </div>
//                         </Link>

//                         <button
//                           type="button"
//                           aria-label="Save property"
//                           onClick={() =>
//                             toggleFavorite({
//                               propertyId: p._id,
//                               favId: p.favorite_id,
//                               saved: p.is_favorite,
//                             })
//                           }
//                           className="absolute z-10 flex items-center justify-center bg-white rounded-full shadow top-1.5 right-1.5 w-6 h-6"
//                         >
//                           <FiHeart size={12} className={p.is_favorite ? "fill-red-600 text-red-600" : "text-gray-500"} />
//                         </button>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </Slider>
//             </section>
//           )}
//         </section>
//       </main>

//       {/* Mobile sticky action bar */}
//       <div className="fixed inset-x-0 bottom-0 z-40 flex gap-2 p-2.5 bg-white border-t shadow-lg lg:hidden">
//         <button
//           type="button"
//           onClick={handleContactClick}
//           className="flex items-center justify-center flex-1 gap-1.5 py-2.5 text-sm font-semibold text-white bg-[#7a1630] rounded-lg"
//         >
//           <FiPhone size={14} /> Call Owner
//         </button>
//         <button
//           type="button"
//           onClick={scrollToEnquiry}
//           className="flex items-center justify-center flex-1 gap-1.5 py-2.5 text-sm font-semibold text-white bg-[#c98a1b] rounded-lg"
//         >
//           <FiMessageCircle size={14} /> Enquire
//         </button>
//       </div>

//       {/* Gallery modal */}
//       {showAllImages && (
//         <div
//           className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/75"
//           onClick={() => setShowAllImages(false)}
//         >
//           <div
//             className="relative w-full max-w-5xl max-h-[90vh] p-5 overflow-auto bg-white rounded-2xl"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <button
//               type="button"
//               aria-label="Close gallery"
//               onClick={() => setShowAllImages(false)}
//               className="absolute text-3xl leading-none text-gray-600 top-3 right-4"
//             >
//               ×
//             </button>
//             <h2 className="mb-3 text-xl font-semibold">Gallery</h2>
//             <div className="grid grid-cols-1 gap-2.5 sm:grid-cols-2 md:grid-cols-3">
//               {galleryImages.map((src, i) => (
//                 <img
//                   key={src}
//                   src={src}
//                   alt={`Photo ${i + 1}`}
//                   className="object-cover w-full h-44 rounded-lg"
//                 />
//               ))}
//               {hasVideo && (
//                 <video controls className="object-cover w-full h-44 rounded-lg">
//                   <source src={d.property_video} type="video/mp4" />
//                   Your browser does not support the video tag.
//                 </video>
//               )}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Modals */}
//       {isTourOpen && (
//         <GetScheduleVTourproperty
//           onClose={() => setIsTourOpen(false)}
//           propertyDetails={propertyDetails}
//           setScheduledDateLabel={setScheduledDateLabel}
//           setIsModalOpen={setIsTourOpen}
//         />
//       )}

//       {isContactOpen && userDetails?.full_name && (
//         <ContactDetails
//           onClose={() => setIsContactOpen(false)}
//           fullName={isLocked ? `****${userDetails.full_name.slice(-1)}` : userDetails.full_name}
//           mobile={
//             isLocked
//               ? `********${(userDetails.mobile_number || "").slice(-3) || "000"}`
//               : userDetails.mobile_number || "N/A"
//           }
//           userEmail={
//             isLocked
//               ? userDetails.email
//                 ? `*******${userDetails.email.slice(-3)}`
//                 : "N/A"
//               : userDetails.email || "N/A"
//           }
//           showUpgradePrompt={isLocked}
//         />
//       )}

//       {isShareOpen && (
//         <ShareModal
//           currentShareUrl={window.location.href}
//           closeShareModal={() => setIsShareOpen(false)}
//           copyLink={copyLink}
//         />
//       )}

//       <Login1
//         isOpen={isLoginOpen}
//         onClose={() => setIsLoginOpen(false)}
//         onSwitchToSignUp={() => {
//           setIsLoginOpen(false);
//           setIsSignUpOpen(true);
//         }}
//         onLoginSuccess={handleLoginSuccess}
//       />
//       <SignUp1
//         isOpen={isSignUpOpen}
//         onClose={() => setIsSignUpOpen(false)}
//         onSwitchToLogin={() => {
//           setIsSignUpOpen(false);
//           setIsLoginOpen(true);
//         }}
//       />
//     </div>
//   );
// };

// export default Detail;




import React, { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import { Link, useHistory, useParams } from "react-router-dom";
import Slider from "react-slick";
import { toast } from "react-toastify";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../styles/RecommendedProperties.css";
import {
  FiCamera,
  FiCheckCircle,
  FiChevronLeft,
  FiChevronRight,
  FiExternalLink,
  FiFileText,
  FiGrid,
  FiHeart,
  FiLayers,
  FiMapPin,
  FiMaximize2,
  FiMessageCircle,
  FiPhone,
  FiUser,
} from "react-icons/fi";
import {
  FaBath,
  FaBed,
  FaBuilding,
  FaCalendarCheck,
  FaCar,
  FaCheck,
  FaClipboardList,
  FaCoins,
  FaCouch,
  FaGem,
  FaHome,
  FaMoneyBillWave,
  FaRulerCombined,
  FaRupeeSign,
  FaUsers,
  FaWhatsapp,
} from "react-icons/fa";
import { PiCubeFocus } from "react-icons/pi";
import Login1 from "../auth/Login1";
import SignUp1 from "../auth/SignUp1";
import GetScheduleVTourproperty from "../containers/GetScheduleVTourproperty";
import ShareModal from "../containers/ShareModal";
import ContactDetails from "../containers/ContactDetails";

/* ------------------------------------------------------------------ */
/* Constants & helpers (outside component so they never re-create)    */
/* ------------------------------------------------------------------ */

const API_BASE = process.env.REACT_APP_API_URL;
const DEFAULT_IMAGE = "/image/appstore.png";
const api = (path) => `${API_BASE}/cust_api/${path}`;

const UNIT_TO_SQFT = {
  "sq ft": 1,
  sqft: 1,
  "square feet": 1,
  "sq yd": 9,
  sqyd: 9,
  "square yards": 9,
  "sq mt": 10.7639,
  sqmt: 10.7639,
  "square meters": 10.7639,
  acre: 43560,
  acres: 43560,
};

const formatArea = (area, unit) => {
  if (!area || !unit) return null;
  const num = parseFloat(area);
  if (isNaN(num)) return null;
  const sqft = num * (UNIT_TO_SQFT[unit.toLowerCase()] ?? 1);
  return `${Math.round(sqft).toLocaleString("en-IN")} Sq.Ft.`;
};

const formatINR = (value) =>
  value ? `₹ ${Number(value).toLocaleString("en-IN")}` : null;

const formatPriceShort = (price) => {
  if (!price) return "";
  if (price >= 10000000) return `${parseFloat((price / 10000000).toFixed(1))} Cr`;
  if (price >= 100000) return `${parseFloat((price / 100000).toFixed(1))} L`;
  if (price >= 1000) return `${parseFloat((price / 1000).toFixed(1))} K`;
  return price;
};

const resolveImage = (src) => {
  if (typeof src !== "string" || !src.trim()) return null;
  return src.startsWith("http") ? src : `${API_BASE}${src}`;
};

const categoryBadge = (type) =>
  type === "Rent"
    ? { label: "FOR RENT", cls: "bg-blue-500" }
    : type === "Buy"
      ? { label: "FOR BUY", cls: "bg-green-600" }
      : { label: "UNKNOWN", cls: "bg-gray-500" };

const fallbackCopy = (text) => {
  const area = document.createElement("textarea");
  area.value = text;
  area.style.position = "fixed";
  area.style.left = "-9999px";
  document.body.appendChild(area);
  area.select();
  try {
    document.execCommand("copy") ? toast.success("Link copied!") : toast.error("Copy failed");
  } catch {
    toast.error("Copy failed");
  }
  document.body.removeChild(area);
};

/* ----- Overview fields: [label, key, icon] ------------------------- */
const OVERVIEW_FIELDS = [
  ["Status", "available_status", FiCheckCircle],
  ["Added On", "property_added_date", FaCalendarCheck],
  ["Listing Type", "property_category_type", FaHome],
  ["Building Type", "building_type", FaBuilding],
  ["Property Type", "property_type", FaBuilding],
  ["BHK Type", "bhk_type", FaBed],
  ["Furnishing", "furnished_type", FaCouch],
  ["Area Type", "area_type", FaRulerCombined],
  ["Operating Since", "operating_since", FaCalendarCheck],
  ["Available For", "available_for", FaUsers],
  ["Suited For", "suited_for", FaUsers],
  ["Room Type", "room_type", FaBed],
  ["Food Charges Included", "food_charges_included", FaMoneyBillWave],
  ["Company Lease", "available_for_company_lease", FaClipboardList],
];

/* ----- More-details fields grouped by category --------------------- */
const DETAIL_CATEGORIES = [
  {
    id: "structure",
    label: "Building & Structure",
    icon: FaBuilding,
    accent: "bg-indigo-50 text-indigo-600",
    fields: [
      ["Total Floor", "total_floor"],
      ["Property Floor", "property_floor"],
      ["Facing", "facing"],
      ["Flooring", "flooring"],
      ["Ceiling Height", "ceiling_height"],
      ["Age of Property", "age_of_property"],
      ["Type of Construction", "type_of_construction"],
      ["Quality Rating", "quality_rating"],
      ["Builder Floor Type", "builder_floor_type"],
      ["Block", "block"],
      ["Developer", "developer"],
      ["Project Type", "project_type"],
      ["Office Space Type", "office_space_type"],
    ],
  },
  {
    id: "parking",
    label: "Parking & Utilities",
    icon: FaCar,
    accent: "bg-amber-50 text-amber-600",
    fields: [
      ["Covered Parking", "covered_parking"],
      ["Uncovered Parking", "uncovered_parking"],
      ["Parking Availability", "parking_availability"],
      ["Parking Types", "parking_types"],
      ["Total Parking", "total_number_parking"],
      ["Lift Availability", "lift_availability"],
      ["Power Backup", "power_backup"],
      ["Water Source", "water_source"],
      ["Central AC", "central_AC"],
    ],
  },
  {
    id: "rooms",
    label: "Rooms & Spaces",
    icon: FaBath,
    accent: "bg-rose-50 text-rose-600",
    fields: [
      ["Total Beds", "total_beds"],
      ["Available Beds", "available_beds"],
      ["Additional Rooms", "additional_rooms"],
      ["Bathroom", "bathroom"],
      ["Attached Bathroom", "attached_bathroom"],
      ["Min. Bathrooms", "number_of_minimum_bathrooms"],
      ["Attached Balcony", "attached_balcony"],
      ["Balcony", "balcony"],
      ["Pantry", "pantry"],
      ["Pantry Option", "pantry_option"],
      ["Personal Washroom", "personal_washroom"],
      ["Commercial Washroom", "commercial_washroom"],
      ["No. of Cabins", "no_of_cabines"],
      ["Meeting Rooms", "no_of_meeting_Rooms"],
      ["Conference Rooms", "no_of_conference_room"],
      ["Reception Area", "reception_area"],
      ["No. of Peoples", "no_of_peoples"],
      ["Seat Type", "seat_type"],
      ["Seats Available", "number_of_seats_available"],
      ["View", "view"],
    ],
  },
  {
    id: "lease",
    label: "Lease & Possession",
    icon: FaCalendarCheck,
    accent: "bg-emerald-50 text-emerald-600",
    fields: [
      ["Notice Period", "notice_period"],
      ["Notice Period (Days)", "notice_period_other_days"],
      ["Min. Lock-in Period", "min_lockin_period"],
      ["Possession Status", "possession_status"],
      ["Possession Date", "possession_date"],
      ["Possession By", "possession_by"],
      ["Security Deposit Type", "security_deposit_type"],
      ["Maintenance Frequency", "maintenance_frequency"],
      ["Maintenance Cost", "maintenance_cost"],
      ["Maintenance Included", "maintenance_included"],
      ["Transaction Type", "transaction_type"],
      ["Rent Duration", "rent_duration"],
      ["Available From", "available_from"],
      ["Available On", "available_on"],
    ],
  },
  {
    id: "charges",
    label: "Charges & Pricing",
    icon: FaMoneyBillWave,
    accent: "bg-cyan-50 text-cyan-600",
    fields: [
      ["Electricity Charges Included", "electricity_charges_included"],
      ["Tax & Govt. Charges", "tax_and_goverment_charges"],
      ["Electricity & Water Charges", "electricity_and_water_charges"],
      ["All Inclusive Price", "all_inclusive_price"],
      ["Price Negotiable", "price_negotiable"],
      ["Investment Options", "investment_options"],
      ["Food Available", "food_available"],
      ["PG Rules", "pg_rules"],
      ["PG Services", "pg_services"],
      ["Gate Closing Time", "gate_closing_time"],
      ["Gate Closing Hour", "gate_closing_hour"],
    ],
  },
  {
    id: "land",
    label: "Land & Dimensions",
    icon: FaRulerCombined,
    accent: "bg-violet-50 text-violet-600",
    fields: [
      ["Plot No.", "plot_no"],
      ["Dimensions (L)", "property_dimensions_length"],
      ["Dimensions (B)", "property_dimensions_breadth"],
      ["Length of Land", "length_of_land"],
      ["Breadth of Land", "breadthOfLand"],
      ["Open Sides", "openSidesOfLand"],
      ["No. of Open Sides", "no_of_open_sides"],
      ["Construction on Land", "constructionOnLand"],
      ["Selected Construction", "selectedConstructionOnLand"],
      ["Carpet Area", "carpet_area"],
      ["Carpet Area Unit", "carpet_area_unit"],
    ],
  },
  {
    id: "other",
    label: "Other Details",
    icon: FaClipboardList,
    accent: "bg-slate-100 text-slate-600",
    fields: [
      ["RERA ID", "property_no"],
      ["Landmarks", "landmarks"],
      ["Near Landmark", "near_landmark"],
      ["Flat Name", "flat_name"],
    ],
  },
];

const TABS = [
  { key: "overview", label: "Overview", icon: FiFileText },
  { key: "amenities", label: "Amenities", icon: FiGrid },
  { key: "similar", label: "Similar Properties", icon: FiLayers },
];

const SIMILAR_SLIDER_SETTINGS = {
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3500,
  arrows: false,
  responsive: [
    { breakpoint: 1024, settings: { slidesToShow: 2 } },
    { breakpoint: 640, settings: { slidesToShow: 1 } },
  ],
};

/* ------------------------------------------------------------------ */
/* Component                                                          */
/* ------------------------------------------------------------------ */

const Detail = () => {
  const { _id } = useParams();
  const history = useHistory();
  const sliderRef = useRef(null);

  const userId = sessionStorage.getItem("accessToken");
  const userType = sessionStorage.getItem("user_type");

  const [propertyDetails, setPropertyDetails] = useState({});
  const [propertyImages, setPropertyImages] = useState([]);
  const [allAmenities, setAllAmenities] = useState([]);
  const [aboutPropertyText, setAboutPropertyText] = useState("");
  const [userDetails, setUserDetails] = useState({
    full_name: "",
    mobile_number: "",
    email: "",
  });
  const [coords, setCoords] = useState({ lat: 0, lng: 0 });
  const [tourSchedule, setTourSchedule] = useState([]);
  const [scheduledDateLabel, setScheduledDateLabel] = useState("Virtual Tour");
  const [similarProperties, setSimilarProperties] = useState([]);

  const [isFavorite, setIsFavorite] = useState(false);
  const [favoriteId, setFavoriteId] = useState(null);
  const [freeViewCount, setFreeViewCount] = useState(0);
  const [paidViewCount, setPaidViewCount] = useState(0);

  const [activeImg, setActiveImg] = useState(0);
  const [activeTab, setActiveTab] = useState("overview");
  const [showAllImages, setShowAllImages] = useState(false);
  const [showAllAmenities, setShowAllAmenities] = useState(false);
  const [openCategory, setOpenCategory] = useState(null);
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [isContactOpen, setIsContactOpen] = useState(false);
  const [isShareOpen, setIsShareOpen] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [isSignUpOpen, setIsSignUpOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(Boolean(userId));
  const [pendingAction, setPendingAction] = useState(null);

  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [contactNumber, setContactNumber] = useState(
    () => sessionStorage.getItem("Mobile_Number") || "",
  );
  const [enquiryStatus, setEnquiryStatus] = useState(null);

  const checkPostLimits = async () => {
    if (!userId) return;
    try {
      const form = new FormData();
      form.append("user_id", userId);
      const { data } = await axios.post(api("get_profile"), form);
      const counts = data?.count_data;
      if (counts) {
        setFreeViewCount(counts.free_view_count || 0);
        setPaidViewCount(counts.paid_view_count || 0);
      }
    } catch (err) {
      console.error("Error checking post limits:", err);
    }
  };

  const handleAddCount = async (updatedCount) => {
    try {
      const form = new FormData();
      form.append(
        freeViewCount > 0 ? "free_view_count" : "paid_view_count",
        updatedCount,
      );
      form.append("user_id", userId);
      const res = await fetch(api("add_count"), { method: "POST", body: form });
      if (res.ok) checkPostLimits();
    } catch (err) {
      console.error("API error:", err);
    }
  };

  const fetchSimilarProperties = async () => {
    try {
      const { data } = await axios.post(api("get_featured_property"), {
        user_id: userId,
      });
      setSimilarProperties(
        data?.status === 1 && Array.isArray(data.data) ? data.data : [],
      );
    } catch (err) {
      console.error("Error fetching similar properties:", err);
    }
  };

  const checkIfFavorite = async (propertyId) => {
    if (!userId || !propertyId) return;
    try {
      const { data } = await axios.post(api("get_favorite_properties"), {
        user_id: userId,
      });
      const match = (data?.data || []).find(
        (fav) => String(fav._id) === String(propertyId),
      );
      setIsFavorite(Boolean(match));
      setFavoriteId(match?.favorite_id ?? null);
    } catch (err) {
      console.error("Error checking favorite status:", err);
    }
  };

  const fetchPropertyDetails = async (id) => {
    try {
      const { data: res } = await axios.post(api("get_property_details"), {
        property_id: id,
        user_id: userId,
      });
      const data = res?.data || {};
      const pd = data.property_details || {};

      setPropertyImages(data.property_images || []);
      setAllAmenities(data.amenities || []);
      setAboutPropertyText(pd.property_description || "");
      setPropertyDetails(pd);
      setCoords({ lat: pd.latitude || 0, lng: pd.longitude || 0 });

      const owner =
        Array.isArray(data.user_details) && data.user_details.length
          ? data.user_details[0]
          : null;
      setUserDetails(
        owner || { full_name: "N/A", mobile_number: "N/A", email: "N/A" },
      );

      const schedule = data.tour_schedule?.[0];
      if (schedule && !["Rejected", "Expired"].includes(schedule.status)) {
        setTourSchedule(data.tour_schedule);
        const [year, month, day] = schedule.schedule_date.split("-");
        const monthName = new Date(0, parseInt(month, 10) - 1).toLocaleString(
          "default",
          { month: "short" },
        );
        setScheduledDateLabel(
          `Scheduled ${parseInt(day, 10)} ${monthName} ${year.slice(-2)}`,
        );
      } else {
        setTourSchedule([]);
        setScheduledDateLabel("Virtual Tour");
      }
    } catch (err) {
      console.error("Error fetching property details", err);
      setPropertyImages([]);
      setAllAmenities([]);
      setTourSchedule([]);
    }
  };

  const toggleFavorite = async ({ propertyId, favId, saved }) => {
    if (!userId) {
      setIsLoginOpen(true);
      return;
    }
    try {
      if (saved) {
        await axios.delete(api("remove_from_favorite"), {
          data: { favorite_id: favId },
        });
        toast.success("Property removed from your favorites.");
      } else {
        await axios.post(api("add_to_favorite"), {
          user_id: userId,
          property_id: propertyId,
        });
        toast.success("Property has been saved to your favorites!");
      }
      checkIfFavorite(propertyDetails?._id);
      fetchSimilarProperties();
    } catch (err) {
      console.error("Favorite update failed:", err);
      toast.error("Could not update favourites. Please try again.");
    }
  };

  const handleEnquirySubmit = async (e) => {
    e.preventDefault();
    if (!userId) {
      setIsLoginOpen(true);
      return;
    }
    try {
      const { data } = await axios.post(api("add_property_enquiry"), {
        property_id: propertyDetails?._id,
        user_id: propertyDetails?.user_id,
        customer_id: userId,
        name,
        user_type: userType,
        contact_number: contactNumber,
        message,
      });
      if (data?.status) {
        setEnquiryStatus({ type: "success", message: "Enquiry sent successfully!" });
        setName("");
        setMessage("");
      } else {
        setEnquiryStatus({ type: "error", message: "Failed to send enquiry!" });
      }
    } catch {
      setEnquiryStatus({ type: "error", message: "Something went wrong!" });
    }
  };

  useEffect(() => {
    checkPostLimits();
    fetchSimilarProperties();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    setActiveImg(0);
    fetchPropertyDetails(_id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_id]);

  useEffect(() => {
    checkIfFavorite(propertyDetails?._id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propertyDetails?._id]);

  useEffect(() => {
    const d = propertyDetails;
    if (!d?._id || !d?.user_id || !userId) return;
    const form = new FormData();
    form.append("property_id", d._id);
    form.append("user_id", d.user_id);
    form.append("customer_id", userId);
    axios
      .post(api("add_view_property"), form)
      .catch((err) => console.error("Failed to record property view:", err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propertyDetails?._id]);

  useEffect(() => {
    if (!isLoggedIn || !pendingAction) return;
    if (pendingAction === "tour") setIsTourOpen(true);
    if (pendingAction === "contact") {
      checkPostLimits();
      setIsContactOpen(true);
    }
    setPendingAction(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn, pendingAction]);

  useEffect(() => {
    const locked = isShareOpen || isContactOpen || showAllImages || isTourOpen;
    document.body.style.overflow = locked ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isShareOpen, isContactOpen, showAllImages, isTourOpen]);

  const requireLogin = (action) => {
    if (userId) return true;
    setPendingAction(action);
    setIsLoginOpen(true);
    return false;
  };

  const handleLoginSuccess = () => {
    const mobile = sessionStorage.getItem("Mobile_Number");
    if (!mobile) return;
    setContactNumber(mobile);
    setIsLoginOpen(false);
    setIsLoggedIn(true);
  };

  const handleContactClick = () => {
    if (!requireLogin("contact")) return;
    if (!userDetails?.full_name) {
      toast.error("User data not found");
      return;
    }
    if (freeViewCount > 0) {
      setFreeViewCount(-1);
      handleAddCount(-1);
    } else if (paidViewCount > 0) {
      setPaidViewCount(-1);
      handleAddCount(-1);
    }
    setIsContactOpen(true);
  };

  const handleTourClick = () => {
    if (scheduledDateLabel !== "Virtual Tour") {
      history.push({ pathname: "/dashboard", state: { page: "myVirtualtour" } });
      return;
    }
    if (requireLogin("tour")) setIsTourOpen(true);
  };

  const copyLink = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied!");
    } catch {
      fallbackCopy(url);
    }
  };

  const scrollToEnquiry = () =>
    document
      .getElementById("enquiry")
      ?.scrollIntoView({ behavior: "smooth", block: "center" });

  const goToTab = (key) => {
    setActiveTab(key);
    document
      .getElementById(`sec-${key}`)
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const d = propertyDetails || {};
  const isRent = d.property_category_type === "Rent";
  const headlinePrice = isRent ? d.rent : d.property_price;
  const locality = [d.address_area, d.city_name].filter(Boolean).join(", ");
  const fullAddress = [d.address, d.city_name, d.state, d.zip_code]
    .filter(Boolean)
    .join(", ");
  const mapsLink =
    coords.lat && coords.lng
      ? `https://www.google.com/maps?q=${coords.lat},${coords.lng}`
      : null;
  const mapEmbed = `https://maps.google.com/maps?q=${coords.lat},${coords.lng}&z=15&output=embed`;

  const galleryImages = useMemo(
    () =>
      [
        ...new Set(
          [d.cover_image, ...propertyImages.map((i) => i.image)]
            .map(resolveImage)
            .filter(Boolean),
        ),
      ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [d.cover_image, propertyImages],
  );

  const hasVideo = Boolean(d.property_video);
  const totalPhotos = galleryImages.length + (hasVideo ? 1 : 0);
  const currentImage = galleryImages[activeImg] || galleryImages[0] || DEFAULT_IMAGE;
  const extraCount = Math.max(galleryImages.length - 4, 0) + (hasVideo ? 1 : 0);

  const stepImage = (dir) => {
    if (!galleryImages.length) return;
    setActiveImg((i) => (i + dir + galleryImages.length) % galleryImages.length);
  };

  const isLocked = freeViewCount <= 0 && paidViewCount <= 0;

  const stats = [
    headlinePrice && {
      icon: FaRupeeSign,
      label: isRent
        ? d.all_inclusive_price === "Yes"
          ? "Rent (Inclusive)"
          : "Rent"
        : "Price",
      value: `${formatINR(headlinePrice)}${isRent ? " / Month" : ""}${
        isRent && d.rent_duration ? ` (${d.rent_duration})` : ""
      }`,
    },
    d.custom_deposit_amount && {
      icon: FaCoins,
      label: "Security Deposit",
      value: formatINR(d.custom_deposit_amount),
    },
    d.area && {
      icon: FaRulerCombined,
      label: "Built-up Area",
      value: formatArea(d.area, d.area_in),
    },
  ].filter((s) => s && s.value);

  const chips = [
    { icon: FaBed, title: d.bhk_type, sub: d.property_type || "Property Type" },
    { icon: FaCouch, title: d.furnished_type, sub: "Furnishing" },
    {
      icon: FaUsers,
      title: d.suited_for || d.available_for,
      sub: isRent ? "Preferred Tenants" : "Suited For",
    },
    { icon: FaCalendarCheck, title: d.available_status, sub: "Availability" },
  ].filter((c) => c.title);

  const highlights = useMemo(() => {
    if (Array.isArray(d.key_highlights) && d.key_highlights.length) return d.key_highlights;
    return [
      d.furnished_type && `${d.furnished_type} property`,
      d.lift_availability && `Lift: ${d.lift_availability}`,
      d.power_backup && `Power backup: ${d.power_backup}`,
      d.facing && `${d.facing} facing`,
      d.parking_availability && `Parking: ${d.parking_availability}`,
      (d.near_landmark || d.landmarks) && `Near ${d.near_landmark || d.landmarks}`,
      d.water_source && `Water: ${d.water_source}`,
    ].filter(Boolean);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propertyDetails]);

  const overviewTiles = [
    { label: "Address", value: fullAddress, icon: FiMapPin },
    { label: "Area", value: formatArea(d.area, d.area_in), icon: FaRulerCombined },
    ...OVERVIEW_FIELDS.map(([label, key, icon]) => ({ label, value: d[key], icon })),
  ].filter((t) => t.value);

  const detailGroups = useMemo(
    () =>
      DETAIL_CATEGORIES.map((cat) => ({
        ...cat,
        rows: cat.fields
          .map(([label, key]) => [
            label,
            key === "maintenance_included"
              ? d.maintenance_included
                ? "Yes"
                : null
              : d[key],
          ])
          .filter(([, value]) => value),
      })).filter((cat) => cat.rows.length > 0),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [propertyDetails],
  );

  useEffect(() => {
    if (detailGroups.length > 0 && openCategory === null) {
      setOpenCategory(detailGroups[0].id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [detailGroups.length]);

  const visibleAmenities = showAllAmenities ? allAmenities : allAmenities.slice(0, 9);

  const tourButtonClass =
    tourSchedule?.[0]?.status === "Accepted"
      ? "bg-green-600 text-white"
      : scheduledDateLabel === "Virtual Tour"
        ? "bg-white border border-[#7a1630] text-[#7a1630]"
        : "bg-[#c98a1b] text-white";

  return (
    <div className="min-h-screen bg-white pb-20 lg:pb-8">
      <main className="max-w-7xl px-4 mx-auto mt-4 sm:px-6">
        {/* ============ HERO SECTION ============ */}
        <section className="grid items-start grid-cols-1 gap-3 lg:grid-cols-12">
          {/* Left Column: Gallery + Overview */}
          <div className="flex flex-col gap-2.5 lg:col-span-5">
            <div className="relative overflow-hidden bg-white shadow-sm rounded-2xl">
              <img
                src={currentImage}
                alt={d.property_name || "Property"}
                onClick={() => setShowAllImages(true)}
                className="object-cover w-full cursor-zoom-in h-40 sm:h-58 lg:h-68"
              />

              <span
                className={`absolute top-2.5 left-2.5 flex items-center gap-1.5 px-2.5 py-1 text-[11px] font-semibold text-white rounded-lg shadow ${
                  isRent ? "bg-[#7a1630]" : "bg-green-600"
                }`}
              >
                <FaHome size={11} /> {isRent ? "For Rent" : "For Sale"}
              </span>

              <button
                type="button"
                aria-label="View all photos"
                onClick={() => setShowAllImages(true)}
                className="absolute flex items-center justify-center w-7 h-7 text-white rounded-full top-2.5 right-2.5 bg-black/40"
              >
                <FiMaximize2 size={13} />
              </button>

              {galleryImages.length > 1 && (
                <>
                  <button
                    type="button"
                    aria-label="Previous photo"
                    onClick={() => stepImage(-1)}
                    className="absolute flex items-center justify-center w-7 h-7 text-white -translate-y-1/2 rounded-full left-2 top-1/2 bg-black/40"
                  >
                    <FiChevronLeft size={15} />
                  </button>
                  <button
                    type="button"
                    aria-label="Next photo"
                    onClick={() => stepImage(1)}
                    className="absolute flex items-center justify-center w-7 h-7 text-white -translate-y-1/2 rounded-full right-2 top-1/2 bg-black/40"
                  >
                    <FiChevronRight size={15} />
                  </button>
                </>
              )}

              {totalPhotos > 0 && (
                <span className="absolute flex items-center gap-1.5 px-2 py-0.5 text-[11px] text-white rounded-lg bottom-2.5 left-2.5 bg-black/50">
                  <FiCamera size={11} /> {Math.min(activeImg + 1, totalPhotos)} / {totalPhotos}
                </span>
              )}
            </div>

            {galleryImages.length > 0 && (
              <div className="grid grid-cols-5 gap-1.5">
                {galleryImages.slice(0, 4).map((src, i) => (
                  <button
                    type="button"
                    key={src}
                    onClick={() => setActiveImg(i)}
                    className={`h-12 sm:h-14 overflow-hidden rounded-lg border-2 ${
                      i === activeImg ? "border-[#7a1630]" : "border-transparent"
                    }`}
                  >
                    <img src={src} alt="" className="object-cover w-full h-full" />
                  </button>
                ))}
                {extraCount > 0 && (
                  <button
                    type="button"
                    onClick={() => setShowAllImages(true)}
                    className="flex flex-col items-center justify-center h-12 text-xs font-semibold text-[#7a1630] bg-white border rounded-lg sm:h-14 border-slate-200"
                  >
                    +{extraCount}
                    <span className="text-[9px] font-normal text-gray-500">More</span>
                  </button>
                )}
              </div>
            )}

            {overviewTiles.length > 0 && (
              <section
                id="sec-overview"
                className="p-3 bg-white shadow-sm scroll-mt-16 rounded-2xl"
              >
                <h2 className="flex items-center gap-2 text-sm font-bold text-gray-900">
                  <span className="flex items-center justify-center w-7 h-7 rounded-lg bg-[#fbf1f3] text-[#7a1630]">
                    <FiFileText size={13} />
                  </span>
                  Overview
                </h2>
                <div className="grid grid-cols-2 gap-2 mt-2.5">
                  {overviewTiles.map(({ label, value, icon: Icon }) => (
                    <div
                      key={label}
                      className="flex items-start gap-2 p-2 border rounded-lg border-slate-100 bg-slate-50/70"
                    >
                      <span className="flex items-center justify-center w-7 h-7 text-[#7a1630] bg-white rounded-md shadow-sm shrink-0">
                        <Icon size={12} />
                      </span>
                      <div className="min-w-0">
                        <p className="text-[10px] text-gray-500 leading-tight">{label}</p>
                        <p className="text-xs font-semibold text-gray-900 break-words leading-snug">
                          {value}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </section>
            )}
          </div>

          {/* Right Column: Info Panel */}
          <div className="lg:col-span-7">
            <div className="p-3 bg-white shadow-sm rounded-2xl">
              <h1 className="text-lg font-bold leading-snug text-gray-900 sm:text-xl">
                {d.property_name || "Property"}
                {d.property_no && (
                  <span className="ml-1.5 text-xs font-normal text-gray-400">
                    – {d.property_no}
                  </span>
                )}
              </h1>

              <div className="flex flex-wrap items-center gap-x-2 gap-y-1 mt-1 text-xs text-gray-600">
                <span className="flex items-center gap-1">
                  <FiMapPin className="text-[#7a1630] shrink-0" size={12} />
                  {locality || "Address N/A"}
                </span>
                {mapsLink && (
                  <>
                    <span className="text-gray-300">|</span>
                    <a
                      href={mapsLink}
                      target="_blank"
                      rel="noreferrer"
                      className="font-medium text-[#7a1630] hover:underline"
                    >
                      Explore Nearby
                    </a>
                  </>
                )}
              </div>

              {stats.length > 0 && (
                <div className="grid grid-cols-1 mt-2 overflow-hidden divide-y rounded-xl bg-[#fbf1f3] sm:grid-cols-3 sm:divide-x sm:divide-y-0">
                  {stats.map(({ icon: Icon, label, value }) => (
                    <div key={label} className="flex items-center gap-2 p-2">
                      <span className="flex items-center justify-center w-7 h-7 text-[#7a1630] bg-white rounded-full shrink-0">
                        <Icon size={12} />
                      </span>
                      <div className="min-w-0">
                        <p className="text-sm font-bold text-[#7a1630] truncate">{value}</p>
                        <p className="text-[10px] text-gray-500 leading-tight">{label}</p>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {chips.length > 0 && (
                <div className="grid grid-cols-2 gap-1.5 mt-2">
                  {chips.map(({ icon: Icon, title, sub }) => (
                    <div
                      key={sub}
                      className="flex items-center gap-1.5 p-1.5 border rounded-lg border-slate-200"
                    >
                      <Icon className="text-[#7a1630] shrink-0" size={13} />
                      <div className="min-w-0">
                        <p className="text-xs font-semibold text-gray-900 truncate">{title}</p>
                        <p className="text-[10px] text-gray-500 leading-tight">{sub}</p>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              <div className="flex gap-1.5 mt-2">
                <button
                  type="button"
                  onClick={handleContactClick}
                  className="flex items-center justify-center flex-1 gap-1.5 py-2 text-xs font-semibold text-white bg-[#7a1630] rounded-lg hover:bg-[#611126]"
                >
                  <FiPhone size={13} /> Call Owner
                </button>
                <button
                  type="button"
                  onClick={handleContactClick}
                  className="flex items-center justify-center flex-1 gap-1.5 py-2 text-xs font-semibold text-[#7a1630] bg-white border-2 border-[#7a1630] rounded-lg hover:bg-[#fbf1f3]"
                >
                  <FaWhatsapp size={13} /> WhatsApp
                </button>
              </div>
              <div className="flex gap-1.5 mt-1.5">
                <button
                  type="button"
                  onClick={scrollToEnquiry}
                  className="flex items-center justify-center flex-1 gap-1.5 py-2 text-xs font-semibold text-white bg-[#c98a1b] rounded-lg hover:brightness-95"
                >
                  <FiMessageCircle size={13} /> Enquire Now
                </button>
                <button
                  type="button"
                  aria-label="Save property"
                  onClick={() =>
                    d._id &&
                    toggleFavorite({ propertyId: d._id, favId: favoriteId, saved: isFavorite })
                  }
                  className="flex items-center justify-center bg-white border rounded-lg w-9 border-slate-200"
                >
                  <FiHeart
                    size={14}
                    className={isFavorite ? "fill-red-600 text-red-600" : "text-gray-600"}
                  />
                </button>
              </div>

              {d.virtual_tour_availability === "Yes" && (
                <button
                  type="button"
                  onClick={handleTourClick}
                  className={`flex items-center justify-center w-full gap-1.5 py-2 mt-1.5 text-xs font-semibold rounded-lg ${tourButtonClass}`}
                >
                  <PiCubeFocus size={15} />
                  {scheduledDateLabel}
                </button>
              )}
            </div>

            {/* Owner card */}
            <div className="flex items-center justify-between gap-3 p-2.5 mt-2 bg-white border shadow-sm rounded-2xl border-amber-100">
              <div className="flex items-center min-w-0 gap-2.5">
                {userDetails?._id ? (
                  <Link to={`/agentdetail/${userDetails._id}`} className="shrink-0">
                    {userDetails.profile_image ? (
                      <img
                        src={userDetails.profile_image}
                        alt="Owner"
                        className="object-cover rounded-full w-9 h-9"
                      />
                    ) : (
                      <span className="flex items-center justify-center text-white rounded-full w-9 h-9 bg-[#7a1630]">
                        <FiUser size={14} />
                      </span>
                    )}
                  </Link>
                ) : (
                  <span className="flex items-center justify-center text-white rounded-full shrink-0 w-9 h-9 bg-[#7a1630]">
                    <FiUser size={14} />
                  </span>
                )}
                <div className="min-w-0">
                  <p className="text-xs font-semibold text-gray-900 truncate">
                    {userDetails?.full_name || "N/A"}
                  </p>
                  {userDetails?.is_verified ? (
                    <p className="flex items-center gap-1 text-[11px] font-medium text-green-600">
                      <FiCheckCircle size={11} /> Verified Owner
                    </p>
                  ) : (
                    userDetails?.user_type && (
                      <p className="text-[11px] text-gray-500">{userDetails.user_type}</p>
                    )
                  )}
                </div>
              </div>
              <button
                type="button"
                onClick={scrollToEnquiry}
                className="px-3 py-1.5 text-[11px] font-semibold text-green-800 bg-green-100 rounded-lg whitespace-nowrap hover:bg-green-200"
              >
                Start Chat
              </button>
            </div>
          </div>
        </section>

        {/* ============ TABS ============ */}
        <nav className="sticky z-30 mt-1.5 overflow-x-auto bg-white border shadow-sm top-0 rounded-xl border-slate-100">
          <ul className="flex min-w-max">
            {TABS.map(({ key, label, icon: Icon }) => (
              <li key={key} className="flex-1">
                <button
                  type="button"
                  onClick={() => goToTab(key)}
                  className={`flex w-full items-center justify-center gap-1.5 px-3.5 py-2 text-xs font-medium border-b-2 ${
                    activeTab === key
                      ? "border-[#7a1630] text-[#7a1630]"
                      : "border-transparent text-gray-600 hover:text-[#7a1630]"
                  }`}
                >
                  <Icon size={13} /> {label}
                </button>
              </li>
            ))}
          </ul>
        </nav>

        {/* ============ CONTENT SECTIONS ============ */}
        <section className="flex flex-col gap-3 mt-3">
          {/* Description + highlights */}
          <div className="grid gap-3 p-3.5 bg-white shadow-sm rounded-2xl md:grid-cols-5">
            <div className="md:col-span-3">
              <h2 className="pl-2.5 text-sm font-bold text-gray-900 border-l-4 border-[#7a1630]">
                Property Description
              </h2>
              <p className="mt-1.5 text-sm leading-relaxed text-gray-700 whitespace-pre-line">
                {aboutPropertyText || "No description provided."}
              </p>
            </div>

            {highlights.length > 0 && (
              <div className="p-3 md:col-span-2 rounded-xl bg-[#fbf1f3]">
                <h3 className="flex items-center gap-1.5 text-xs font-bold text-[#7a1630]">
                  <FaGem size={11} /> Key Highlights
                </h3>
                <ul className="mt-1.5 space-y-1 text-xs text-gray-800">
                  {highlights.map((h) => (
                    <li key={h} className="flex gap-1.5">
                      <FaCheck className="mt-0.5 text-[#7a1630] shrink-0" size={10} />
                      <span>{h}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>

          {/* More Details */}
          {detailGroups.length > 0 && (
            <section className="p-3.5 bg-white shadow-sm rounded-2xl">
              <h2 className="text-sm font-bold text-gray-900">More Details</h2>
              <div className="mt-2.5 space-y-2">
                {detailGroups.map((cat) => {
                  const isOpen = openCategory === cat.id;
                  const Icon = cat.icon;
                  return (
                    <div key={cat.id} className="overflow-hidden border rounded-xl border-slate-100">
                      <button
                        type="button"
                        onClick={() => setOpenCategory(isOpen ? null : cat.id)}
                        className="flex items-center justify-between w-full gap-2 p-2.5 text-left hover:bg-slate-50"
                      >
                        <span className="flex items-center gap-2 min-w-0">
                          <span className={`flex items-center justify-center w-7 h-7 rounded-lg shrink-0 ${cat.accent}`}>
                            <Icon size={12} />
                          </span>
                          <span className="text-xs font-semibold text-gray-900 truncate">{cat.label}</span>
                          <span className="text-[10px] text-gray-400">({cat.rows.length})</span>
                        </span>
                        <FiChevronRight
                          size={14}
                          className={`text-gray-400 transition-transform shrink-0 ${isOpen ? "rotate-90" : ""}`}
                        />
                      </button>
                      {isOpen && (
                        <div className="grid grid-cols-1 gap-x-4 gap-y-1.5 p-3 pt-0 sm:grid-cols-2">
                          {cat.rows.map(([label, value]) => (
                            <div key={label} className="flex items-baseline justify-between gap-3 py-1 text-xs border-b border-slate-50">
                              <span className="text-gray-500">{label}</span>
                              <span className="font-medium text-right text-gray-900 break-words">{value}</span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </section>
          )}

          {/* Amenities */}
          {allAmenities.length > 0 && (
            <section id="sec-amenities" className="p-3.5 bg-white shadow-sm scroll-mt-16 rounded-2xl">
              <h2 className="text-sm font-bold text-gray-900">Amenities</h2>
              <div className="grid grid-cols-3 gap-2.5 mt-2.5 sm:grid-cols-4 md:grid-cols-5">
                {visibleAmenities.map((amenity, i) => (
                  <div
                    key={`${amenity.name}-${i}`}
                    className="flex flex-col items-center gap-1.5 p-2.5 text-center border rounded-xl border-slate-100 bg-slate-50/60"
                  >
                    {amenity.icon ? (
                      <img
                        src={`${API_BASE}/media/${amenity.icon}`}
                        alt={amenity.name}
                        className="object-contain w-7 h-7"
                      />
                    ) : (
                      <span className="flex items-center justify-center w-9 h-9 rounded-full bg-[#fbf1f3] text-[#7a1630]">
                        <FiCheckCircle size={15} />
                      </span>
                    )}
                    <span className="text-[11px] font-medium text-gray-700 leading-tight line-clamp-2">
                      {amenity.name}
                    </span>
                  </div>
                ))}
              </div>
              {allAmenities.length > 9 && (
                <button
                  type="button"
                  onClick={() => setShowAllAmenities((s) => !s)}
                  className="mt-3 text-xs font-semibold text-[#7a1630] hover:underline"
                >
                  {showAllAmenities ? "Show less" : `+${allAmenities.length - 9} More`}
                </button>
              )}
            </section>
          )}

          {/* Enquiry form */}
          <section id="enquiry" className="p-3.5 bg-white shadow-sm scroll-mt-16 rounded-2xl">
            <h3 className="flex items-center gap-2 text-sm font-bold text-gray-900">
              <span className="flex items-center justify-center w-7 h-7 rounded-lg bg-[#fbf1f3] text-[#7a1630]">
                <FiMessageCircle size={13} />
              </span>
              Make an Enquiry
            </h3>
            <form onSubmit={handleEnquirySubmit} className="grid gap-2 mt-2.5 sm:grid-cols-2">
              <input
                type="text"
                placeholder="Your name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                onFocus={() => !userId && setIsLoginOpen(true)}
                required
                className="w-full p-2 text-xs border rounded-lg outline-none focus:ring-2 focus:ring-[#7a1630]"
              />
              <input
                type="text"
                placeholder="Phone number"
                value={contactNumber}
                readOnly
                className="w-full p-2 text-xs bg-gray-50 border rounded-lg outline-none"
              />
              <textarea
                placeholder="Message"
                rows={3}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onFocus={() => !userId && setIsLoginOpen(true)}
                required
                className="w-full p-2 text-xs border rounded-lg outline-none focus:ring-2 focus:ring-[#7a1630] sm:col-span-2"
              />
              <button
                type="submit"
                className="w-full py-2 text-xs font-semibold text-white bg-[#c98a1b] rounded-lg hover:brightness-95 sm:col-span-2"
              >
                Send an Enquiry
              </button>
            </form>
            {enquiryStatus && (
              <p
                className={`mt-2 text-center text-xs ${
                  enquiryStatus.type === "success" ? "text-green-600" : "text-red-600"
                }`}
              >
                {enquiryStatus.message}
              </p>
            )}
          </section>

          {/* Location */}
          <section id="sec-location" className="p-3.5 bg-white shadow-sm scroll-mt-16 rounded-2xl">
            <div className="flex items-center justify-between">
              <h2 className="flex items-center gap-2 text-sm font-bold text-gray-900">
                <span className="flex items-center justify-center w-7 h-7 rounded-lg bg-[#fbf1f3] text-[#7a1630]">
                  <FiMapPin size={13} />
                </span>
                Location
              </h2>
              {mapsLink && (
                <a
                  href={mapsLink}
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-1 text-xs font-medium text-[#7a1630] hover:underline"
                >
                  Open in Maps <FiExternalLink size={12} />
                </a>
              )}
            </div>
            <p className="mt-1 ml-9 text-xs text-gray-500">{fullAddress || "Address N/A"}</p>
            <div className="mt-2.5 overflow-hidden rounded-xl">
              <iframe
                title="Property location"
                src={mapEmbed}
                className="w-full h-48 md:h-64"
                allowFullScreen
                loading="lazy"
              />
            </div>
          </section>

          {/* Similar properties */}
          {similarProperties.length > 0 && (
            <section id="sec-similar" className="p-3.5 bg-white shadow-sm scroll-mt-16 rounded-2xl">
              <div className="flex flex-wrap items-center justify-between gap-2 mb-2.5">
                <div>
                  <h2 className="text-sm font-bold text-gray-900">Exclusive Recommended</h2>
                  <p className="text-[11px] text-gray-500">Go from browsing to buying</p>
                </div>
                <div className="flex items-center gap-1.5">
                  <button
                    type="button"
                    onClick={() => history.push("/featuredDashboard")}
                    className="px-2.5 py-1 text-[11px] font-medium text-[#7a1630] bg-white border rounded-lg border-[#7a1630]"
                  >
                    View All
                  </button>
                  <button
                    type="button"
                    aria-label="Previous"
                    onClick={() => sliderRef.current?.slickPrev()}
                    className="flex items-center justify-center w-7 h-7 bg-white border rounded-full shadow-sm"
                  >
                    <FiChevronLeft size={13} />
                  </button>
                  <button
                    type="button"
                    aria-label="Next"
                    onClick={() => sliderRef.current?.slickNext()}
                    className="flex items-center justify-center w-7 h-7 bg-white border rounded-full shadow-sm"
                  >
                    <FiChevronRight size={13} />
                  </button>
                </div>
              </div>

              <Slider {...SIMILAR_SLIDER_SETTINGS} ref={sliderRef} className="slider-container">
                {similarProperties.map((p) => {
                  const badge = categoryBadge(p.property_category_type);
                  const cardPrice = p.property_category_type === "Rent" ? p.rent : p.property_price;
                  return (
                    <div key={p._id} className="px-1.5 py-1">
                      <div className="relative overflow-hidden bg-white border shadow-sm rounded-xl border-slate-100">
                        <Link
                          to={`/propertydetails/${p._id}?property_owner_id=${p.user_id}`}
                          onClick={() => window.scrollTo(0, 0)}
                          className="block"
                        >
                          <div className="relative">
                            <img
                              src={resolveImage(p.cover_image) || DEFAULT_IMAGE}
                              alt={p.property_name || "Property"}
                              className="object-cover w-full h-32"
                            />
                            <span className="absolute px-2 py-0.5 text-[10px] text-white rounded-full top-1.5 left-1.5 bg-black/50">
                              {p.days_since_created}d on ZeroBriks
                            </span>
                            <span
                              className={`absolute bottom-0 left-0 px-2.5 py-0.5 text-[10px] text-white rounded-tr-lg ${badge.cls}`}
                            >
                              {badge.label}
                            </span>
                            {p.mark_as_featured === "Yes" && (
                              <span className="absolute bottom-0 right-0 px-2.5 py-0.5 text-[10px] text-white rounded-tl-lg bg-amber-500">
                                FEATURED
                              </span>
                            )}
                          </div>

                          <div className="p-2.5">
                            <h3 className="text-xs font-semibold text-gray-900 truncate">{p.property_name}</h3>
                            <p className="flex items-center gap-1 mt-1 text-[11px] text-gray-500 truncate">
                              <FiMapPin size={10} className="shrink-0" />
                              {p.address_area || "No Address Provided"}
                            </p>
                            <div className="flex flex-wrap gap-x-2.5 gap-y-0.5 mt-1.5 text-[11px] text-gray-700">
                              {cardPrice && (
                                <span className="font-semibold text-[#7a1630]">
                                  ₹{formatPriceShort(cardPrice)}
                                  {p.property_category_type === "Rent" && p.rent_duration
                                    ? ` / ${p.rent_duration}`
                                    : ""}
                                </span>
                              )}
                              {p.bhk_type && <span>{p.bhk_type}</span>}
                              {formatArea(p.area, p.area_in) && <span>{formatArea(p.area, p.area_in)}</span>}
                            </div>
                          </div>
                        </Link>

                        <button
                          type="button"
                          aria-label="Save property"
                          onClick={() =>
                            toggleFavorite({
                              propertyId: p._id,
                              favId: p.favorite_id,
                              saved: p.is_favorite,
                            })
                          }
                          className="absolute z-10 flex items-center justify-center bg-white rounded-full shadow top-1.5 right-1.5 w-6 h-6"
                        >
                          <FiHeart size={12} className={p.is_favorite ? "fill-red-600 text-red-600" : "text-gray-500"} />
                        </button>
                      </div>
                    </div>
                  );
                })}
              </Slider>
            </section>
          )}
        </section>
      </main>

      {/* Mobile sticky action bar */}
      <div className="fixed inset-x-0 bottom-0 z-40 flex gap-2 p-2.5 bg-white border-t shadow-lg lg:hidden">
        <button
          type="button"
          onClick={handleContactClick}
          className="flex items-center justify-center flex-1 gap-1.5 py-2.5 text-sm font-semibold text-white bg-[#7a1630] rounded-lg"
        >
          <FiPhone size={14} /> Call Owner
        </button>
        <button
          type="button"
          onClick={scrollToEnquiry}
          className="flex items-center justify-center flex-1 gap-1.5 py-2.5 text-sm font-semibold text-white bg-[#c98a1b] rounded-lg"
        >
          <FiMessageCircle size={14} /> Enquire
        </button>
      </div>

      {/* Gallery modal */}
      {showAllImages && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/75"
          onClick={() => setShowAllImages(false)}
        >
          <div
            className="relative w-full max-w-5xl max-h-[90vh] p-5 overflow-auto bg-white rounded-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              aria-label="Close gallery"
              onClick={() => setShowAllImages(false)}
              className="absolute text-3xl leading-none text-gray-600 top-3 right-4"
            >
              ×
            </button>
            <h2 className="mb-3 text-xl font-semibold">Gallery</h2>
            <div className="grid grid-cols-1 gap-2.5 sm:grid-cols-2 md:grid-cols-3">
              {galleryImages.map((src, i) => (
                <img
                  key={src}
                  src={src}
                  alt={`Photo ${i + 1}`}
                  className="object-cover w-full h-44 rounded-lg"
                />
              ))}
              {hasVideo && (
                <video controls className="object-cover w-full h-44 rounded-lg">
                  <source src={d.property_video} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modals */}
      {isTourOpen && (
        <GetScheduleVTourproperty
          onClose={() => setIsTourOpen(false)}
          propertyDetails={propertyDetails}
          setScheduledDateLabel={setScheduledDateLabel}
          setIsModalOpen={setIsTourOpen}
        />
      )}

      {isContactOpen && userDetails?.full_name && (
        <ContactDetails
          onClose={() => setIsContactOpen(false)}
          fullName={isLocked ? `****${userDetails.full_name.slice(-1)}` : userDetails.full_name}
          mobile={
            isLocked
              ? `********${(userDetails.mobile_number || "").slice(-3) || "000"}`
              : userDetails.mobile_number || "N/A"
          }
          userEmail={
            isLocked
              ? userDetails.email
                ? `*******${userDetails.email.slice(-3)}`
                : "N/A"
              : userDetails.email || "N/A"
          }
          showUpgradePrompt={isLocked}
        />
      )}

      {isShareOpen && (
        <ShareModal
          currentShareUrl={window.location.href}
          closeShareModal={() => setIsShareOpen(false)}
          copyLink={copyLink}
        />
      )}

      <Login1
        isOpen={isLoginOpen}
        onClose={() => setIsLoginOpen(false)}
        onSwitchToSignUp={() => {
          setIsLoginOpen(false);
          setIsSignUpOpen(true);
        }}
        onLoginSuccess={handleLoginSuccess}
      />
      <SignUp1
        isOpen={isSignUpOpen}
        onClose={() => setIsSignUpOpen(false)}
        onSwitchToLogin={() => {
          setIsSignUpOpen(false);
          setIsLoginOpen(true);
        }}
      />
    </div>
  );
};

export default Detail;